  function julAsset(filename) {
    if (window.JUL_ASSETS && window.JUL_ASSETS[filename]) {
      return window.JUL_ASSETS[filename];
    }
    if (filename.endsWith('.mp4') || filename.endsWith('.mov')) return 'assets/videos/' + filename;
    if (filename.match(/^w-\d{2}\.jpg$/)) return 'assets/workshops/' + filename;
    if (filename.match(/^(stage|studio-[ab])-\d{2}\.jpg$/)) return 'assets/' + filename;
    return 'assets/' + filename;
  }

  // ============================================================
  // 60 ESER HAVUZU — YEREL DOSYALAR (assets/artworks/01.jpg ... 60.jpg)
  // indir.sh scripti bu dosyalari indiriyor
  // ============================================================
  const POOL = [
    { f: "01", title: "Yıldızlı Gece", artist: "Vincent van Gogh", year: "1889", medium: "Yağlı Boya", dims: "74 × 92 cm", style: "Post-Empresyonist", museum: "MoMA, New York" },
    { f: "02", title: "Yatak Odası", artist: "Vincent van Gogh", year: "1889", medium: "Yağlı Boya", dims: "73 × 92 cm", style: "Post-Empresyonist", museum: "Art Institute Chicago" },
    { f: "03", title: "Selvili Buğday Tarlası", artist: "Vincent van Gogh", year: "1889", medium: "Yağlı Boya", dims: "73 × 93 cm", style: "Post-Empresyonist", museum: "The Met, New York" },
    { f: "04", title: "Gece Kafe Terası", artist: "Vincent van Gogh", year: "1888", medium: "Yağlı Boya", dims: "81 × 65 cm", style: "Post-Empresyonist", museum: "Kröller-Müller Müzesi" },
    { f: "05", title: "Otoportre", artist: "Vincent van Gogh", year: "1889", medium: "Yağlı Boya", dims: "65 × 54 cm", style: "Post-Empresyonist", museum: "Musée d'Orsay, Paris" },
    { f: "06", title: "Ayçiçekleri", artist: "Vincent van Gogh", year: "1888", medium: "Yağlı Boya", dims: "92 × 73 cm", style: "Post-Empresyonist", museum: "Van Gogh Müzesi" },
    { f: "07", title: "Empresyon, Gün Doğumu", artist: "Claude Monet", year: "1872", medium: "Yağlı Boya", dims: "48 × 63 cm", style: "Empresyonizm", museum: "Musée Marmottan" },
    { f: "08", title: "Nilüferler", artist: "Claude Monet", year: "1906", medium: "Yağlı Boya", dims: "89 × 94 cm", style: "Empresyonizm", museum: "Art Institute Chicago" },
    { f: "09", title: "Nilüfer Havuzu Köprüsü", artist: "Claude Monet", year: "1899", medium: "Yağlı Boya", dims: "92 × 73 cm", style: "Empresyonizm", museum: "The Met, New York" },
    { f: "10", title: "Adele Bloch-Bauer I", artist: "Gustav Klimt", year: "1907", medium: "Yağlı Boya, Altın", dims: "140 × 140 cm", style: "Sezesyon", museum: "Neue Galerie, New York" },
    { f: "11", title: "Öpücük", artist: "Gustav Klimt", year: "1908", medium: "Yağlı Boya, Altın", dims: "180 × 180 cm", style: "Sezesyon", museum: "Belvedere, Viyana" },
    { f: "12", title: "Delft Manzarası", artist: "Johannes Vermeer", year: "1660-61", medium: "Yağlı Boya", dims: "96 × 115 cm", style: "Barok", museum: "Mauritshuis, Lahey" },
    { f: "13", title: "İnci Küpeli Kız", artist: "Johannes Vermeer", year: "1665", medium: "Yağlı Boya", dims: "44 × 39 cm", style: "Barok", museum: "Mauritshuis, Lahey" },
    { f: "14", title: "Gece Kuşları", artist: "Edward Hopper", year: "1942", medium: "Yağlı Boya", dims: "84 × 152 cm", style: "Realizm", museum: "Art Institute Chicago" },
    { f: "15", title: "Amerikan Gotiği", artist: "Grant Wood", year: "1930", medium: "Yağlı Boya", dims: "78 × 65 cm", style: "Bölgeselcilik", museum: "Art Institute Chicago" },
    { f: "16", title: "La Grande Jatte'de Bir Pazar", artist: "Georges Seurat", year: "1884-86", medium: "Yağlı Boya", dims: "207 × 308 cm", style: "Pointilizm", museum: "Art Institute Chicago" },
    { f: "17", title: "Yaşlı Gitarist", artist: "Pablo Picasso", year: "1903-04", medium: "Yağlı Boya", dims: "123 × 83 cm", style: "Mavi Dönem", museum: "Art Institute Chicago" },
    { f: "18", title: "Avignonlu Kadınlar", artist: "Pablo Picasso", year: "1907", medium: "Yağlı Boya", dims: "244 × 234 cm", style: "Proto-Kübizm", museum: "MoMA, New York" },
    { f: "19", title: "Guernica", artist: "Pablo Picasso", year: "1937", medium: "Yağlı Boya", dims: "349 × 776 cm", style: "Kübizm", museum: "Reina Sofía, Madrid" },
    { f: "20", title: "Büyük Dalga", artist: "Katsushika Hokusai", year: "1831", medium: "Ahşap Baskı", dims: "25 × 37 cm", style: "Ukiyo-e", museum: "Çeşitli Koleksiyonlar" },
    { f: "21", title: "Çığlık", artist: "Edvard Munch", year: "1893", medium: "Karışık Teknik", dims: "91 × 73 cm", style: "Ekspresyonizm", museum: "Ulusal Galeri, Oslo" },
    { f: "22", title: "Belleğin Azmi", artist: "Salvador Dalí", year: "1931", medium: "Yağlı Boya", dims: "24 × 33 cm", style: "Sürrealizm", museum: "MoMA, New York" },
    { f: "23", title: "İnsanoğlu", artist: "René Magritte", year: "1964", medium: "Yağlı Boya", dims: "116 × 89 cm", style: "Sürrealizm", museum: "Özel Koleksiyon" },
    { f: "24", title: "Bu Bir Pipo Değildir", artist: "René Magritte", year: "1929", medium: "Yağlı Boya", dims: "63 × 93 cm", style: "Sürrealizm", museum: "LACMA, Los Angeles" },
    { f: "25", title: "Otoportre", artist: "Frida Kahlo", year: "1940", medium: "Yağlı Boya", dims: "61 × 47 cm", style: "Sürrealizm", museum: "Çeşitli Koleksiyonlar" },
    { f: "26", title: "Dans", artist: "Henri Matisse", year: "1909", medium: "Yağlı Boya", dims: "260 × 391 cm", style: "Modernizm", museum: "MoMA, New York" },
    { f: "27", title: "Kompozisyon VII", artist: "Wassily Kandinsky", year: "1913", medium: "Yağlı Boya", dims: "200 × 300 cm", style: "Soyut", museum: "Tretyakov, Moskova" },
    { f: "28", title: "Ben ve Köy", artist: "Marc Chagall", year: "1911", medium: "Yağlı Boya", dims: "192 × 151 cm", style: "Modernizm", museum: "MoMA, New York" },
    { f: "29", title: "Büyük Odalık", artist: "Jean-Auguste-Dominique Ingres", year: "1814", medium: "Yağlı Boya", dims: "91 × 162 cm", style: "Neoklasik", museum: "Louvre, Paris" },
    { f: "30", title: "Paris Sokağı, Yağmurlu Gün", artist: "Gustave Caillebotte", year: "1877", medium: "Yağlı Boya", dims: "212 × 276 cm", style: "Empresyonizm", museum: "Art Institute Chicago" },
    { f: "31", title: "Moulin de la Galette'de Dans", artist: "Pierre-Auguste Renoir", year: "1876", medium: "Yağlı Boya", dims: "131 × 175 cm", style: "Empresyonizm", museum: "Musée d'Orsay, Paris" },
    { f: "32", title: "Dans Provası", artist: "Edgar Degas", year: "1874", medium: "Yağlı Boya", dims: "85 × 75 cm", style: "Empresyonizm", museum: "Musée d'Orsay, Paris" },
    { f: "33", title: "Kırda Öğle Yemeği", artist: "Édouard Manet", year: "1863", medium: "Yağlı Boya", dims: "208 × 264 cm", style: "Realizm", museum: "Musée d'Orsay, Paris" },
    { f: "34", title: "Olympia", artist: "Édouard Manet", year: "1863", medium: "Yağlı Boya", dims: "130 × 190 cm", style: "Realizm", museum: "Musée d'Orsay, Paris" },
    { f: "35", title: "Venüs'ün Doğuşu", artist: "Sandro Botticelli", year: "1485", medium: "Tempera", dims: "172 × 278 cm", style: "Rönesans", museum: "Uffizi, Floransa" },
    { f: "36", title: "Mona Lisa", artist: "Leonardo da Vinci", year: "1503", medium: "Yağlı Boya", dims: "77 × 53 cm", style: "Rönesans", museum: "Louvre, Paris" },
    { f: "37", title: "Son Akşam Yemeği", artist: "Leonardo da Vinci", year: "1495-98", medium: "Tempera", dims: "460 × 880 cm", style: "Rönesans", museum: "Santa Maria, Milano" },
    { f: "38", title: "Adem'in Yaratılışı", artist: "Michelangelo", year: "1512", medium: "Fresk", dims: "280 × 570 cm", style: "Rönesans", museum: "Sistine Şapeli" },
    { f: "39", title: "Aziz Matta'nın Çağrılışı", artist: "Caravaggio", year: "1600", medium: "Yağlı Boya", dims: "322 × 340 cm", style: "Barok", museum: "San Luigi, Roma" },
    { f: "40", title: "Gece Devriyesi", artist: "Rembrandt", year: "1642", medium: "Yağlı Boya", dims: "363 × 437 cm", style: "Barok", museum: "Rijksmuseum, Amsterdam" },
    { f: "41", title: "Las Meninas", artist: "Diego Velázquez", year: "1656", medium: "Yağlı Boya", dims: "318 × 276 cm", style: "Barok", museum: "Prado, Madrid" },
    { f: "42", title: "Karda Avcılar", artist: "Pieter Bruegel", year: "1565", medium: "Yağlı Boya", dims: "117 × 162 cm", style: "Kuzey Rönesans", museum: "Kunsthistorisches, Viyana" },
    { f: "43", title: "Kağıt Oynayanlar", artist: "Paul Cézanne", year: "1892", medium: "Yağlı Boya", dims: "47 × 57 cm", style: "Post-Empresyonist", museum: "Musée d'Orsay, Paris" },
    { f: "44", title: "Elmalar ve Portakallar", artist: "Paul Cézanne", year: "1899", medium: "Yağlı Boya", dims: "74 × 93 cm", style: "Post-Empresyonist", museum: "Musée d'Orsay, Paris" },
    { f: "45", title: "Çiçekli Kadın", artist: "Paul Gauguin", year: "1891", medium: "Yağlı Boya", dims: "70 × 46 cm", style: "Post-Empresyonist", museum: "Ny Carlsberg Glyptotek" },
    { f: "46", title: "Rüya", artist: "Henri Rousseau", year: "1910", medium: "Yağlı Boya", dims: "204 × 298 cm", style: "Naif Sanat", museum: "MoMA, New York" },
    { f: "47", title: "Beyaz Patiska Çiçek", artist: "Georgia O'Keeffe", year: "1931", medium: "Yağlı Boya", dims: "76 × 91 cm", style: "Modernizm", museum: "Whitney Museum, New York" },
    { f: "48", title: "Campbell's Çorba Konserveleri", artist: "Andy Warhol", year: "1962", medium: "Sentetik Polimer", dims: "51 × 41 cm", style: "Pop Art", museum: "MoMA, New York" },
    { f: "49", title: "Kompozisyon 10", artist: "Piet Mondrian", year: "1939-42", medium: "Yağlı Boya", dims: "80 × 73 cm", style: "De Stijl", museum: "Özel Koleksiyon" },
    { f: "50", title: "Sanatçının Annesi", artist: "James Whistler", year: "1871", medium: "Yağlı Boya", dims: "144 × 162 cm", style: "Realizm", museum: "Musée d'Orsay, Paris" },
    { f: "51", title: "Patates Yiyenler", artist: "Vincent van Gogh", year: "1885", medium: "Yağlı Boya", dims: "82 × 114 cm", style: "Post-Empresyonist", museum: "Van Gogh Müzesi" },
    { f: "52", title: "Toledo Manzarası", artist: "El Greco", year: "1599", medium: "Yağlı Boya", dims: "121 × 109 cm", style: "Maniyerizm", museum: "The Met, New York" },
    { f: "53", title: "Dünyevi Zevkler Bahçesi", artist: "Hieronymus Bosch", year: "1490-1510", medium: "Yağlı Boya", dims: "220 × 389 cm", style: "Kuzey Rönesans", museum: "Prado, Madrid" },
    { f: "54", title: "Halka Önderlik Eden Özgürlük", artist: "Eugène Delacroix", year: "1830", medium: "Yağlı Boya", dims: "260 × 325 cm", style: "Romantizm", museum: "Louvre, Paris" },
    { f: "55", title: "Savaşan Téméraire", artist: "J.M.W. Turner", year: "1839", medium: "Yağlı Boya", dims: "91 × 122 cm", style: "Romantizm", museum: "Ulusal Galeri, Londra" },
    { f: "56", title: "Sis Denizinin Üstündeki Gezgin", artist: "Caspar David Friedrich", year: "1818", medium: "Yağlı Boya", dims: "95 × 75 cm", style: "Romantizm", museum: "Kunsthalle Hamburg" },
    { f: "57", title: "Madame X", artist: "John Singer Sargent", year: "1884", medium: "Yağlı Boya", dims: "234 × 110 cm", style: "Realizm", museum: "The Met, New York" },
    { f: "58", title: "Moulin Rouge'da", artist: "Henri de Toulouse-Lautrec", year: "1892", medium: "Yağlı Boya", dims: "123 × 141 cm", style: "Post-Empresyonist", museum: "Art Institute Chicago" },
    { f: "59", title: "Montmartre Bulvarı", artist: "Camille Pissarro", year: "1897", medium: "Yağlı Boya", dims: "74 × 92 cm", style: "Empresyonizm", museum: "Hermitage, St. Petersburg" },
    { f: "60", title: "Çocuğun Banyosu", artist: "Mary Cassatt", year: "1893", medium: "Yağlı Boya", dims: "100 × 66 cm", style: "Empresyonizm", museum: "Art Institute Chicago" }
  ];

  const DESCRIPTIONS = {
    "Vincent van Gogh": "Van Gogh'un fırça darbeleri tablonun yüzeyinde değil, izleyicinin sinir sisteminde titrer. Saint-Rémy döneminden kalma; ressamın hastalığı ile yaratıcılığının ayrılmaz olduğu bir nefes ritmi.",
    "Claude Monet": "Monet için tablo bir anlık değil, ışığın geçici bir akoru. Aynı manzaranın saat saat değişen yüzü, görmenin kendi geçiciliğine yapılan bir şerh.",
    "Pierre-Auguste Renoir": "Renoir'in figürleri ışığın yumuşak bir kataloğu gibidir. Empresyonizmin neşeli, paradan uzak günlerinden bir kesit.",
    "Paul Cézanne": "Cézanne resmin bir pencere olmaktan çıkıp bir mimari yüzey olduğunu söyledi. Sonraki yüz yılın kübizmine zemin hazırlayan sessiz bir manifesto.",
    "Georges Seurat": "Seurat'nın noktaları teknik bir buluş değil, ışığın atomlarına saygılı bir bilim insanının notasıdır.",
    "Edward Hopper": "Hopper'in figürleri her zaman bir başkasının yokluğuyla tanımlı. Tabloda anlatılan şey çoğunlukla orada olmayan kişidir.",
    "Grant Wood": "Amerikan kırsal kimliğinin ironik portresi. Modernizmin yüzeysel atılganlığına karşı geleneğin pürist bir savunması.",
    "Pablo Picasso": "Picasso bir dönem değil, bir yöntemdir: bakış açısını parçalayıp yeniden monte etmek.",
    "Henri Matisse": "Matisse renkle düşünen bir yapımcıdır. Onun için form, rengin emrindeki bir teşekkürdür.",
    "Henri de Toulouse-Lautrec": "Toulouse-Lautrec, gece hayatının ressamı değil, gece hayatının kendisidir.",
    "Gustave Caillebotte": "Caillebotte fotoğrafın resme henüz dokunduğu anı yakalar. Paris sokakları, modern şehirli yalnızlığın ilk yüzleri.",
    "Edgar Degas": "Degas pastel ve hareketin ressamıdır. Balerinleri, hipodromu, çamaşırhaneyi aynı dikkatle resmeder.",
    "Édouard Manet": "Manet modern resmin başlangıç noktası kabul edilir. Akademik kuralı kıran ilk yumuşak elin sahibi.",
    "Georgia O'Keeffe": "O'Keeffe Amerikan modernizminin yalnız ve haşin sesi. Çiçeği bir manzaraya, kemiği bir psişik duruma çeviren makro bakış.",
    "René Magritte": "Magritte için resim bir bilmecedir. Aslında nesneyi göstermez, nesnenin bizdeki tortusunu sorgular.",
    "Salvador Dalí": "Dalí rüya ile takıntı arasındaki ince zarı resmetmek için bir mühendisin kesinliğini kullanır.",
    "Marc Chagall": "Chagall'in figürleri yerçekiminden muaftır. Belarus, Rusya, İncil, halk masalı — hepsi aynı hayalî hava akımında yüzer.",
    "Wassily Kandinsky": "Kandinsky için resim bir müzik teorisidir. Soyut, ona göre, bir kaçış değil daha köklü bir gerçeğe varış.",
    "Camille Pissarro": "Pissarro empresyonizmin en uzun soluklu, en sebatlı sesi. Köy ile şehri aynı ışıkla tanımlar.",
    "Paul Gauguin": "Gauguin Tahiti'ye Avrupa'dan kaçtı, ama Avrupa'nın gözünü götürdü. Tropikal palet, sömürgeci bakışın da ressamı.",
    "John Singer Sargent": "Sargent yüksek sosyetenin portrelerinde, modeline değil onun arkasındaki güç yapısına bakar.",
    "Katsushika Hokusai": "Hokusai için dağ bir nesne değil, bir karakter. Fuji'nin yüz farklı yüzü, Japon manzara resminin Batı'ya ihraç edilen anahtarı.",
    "El Greco": "El Greco İspanyol mistisizmini renge çevirir. Uzayan figürleri, dini coşkunun fiziksel bir tezahürü.",
    "Caravaggio": "Caravaggio ışığı bir hançer gibi kullandı. Sahnelerini hep bir tiyatro sahnesinde, en yüksek dramatik anda kesti.",
    "Sandro Botticelli": "Botticelli Rönesans'ın lirizmidir. Mitolojiyi naif bir zarafetle resme taşır.",
    "Leonardo da Vinci": "Da Vinci için resim, bilimin de bir formuydu. Anatomiyi, optiği, mimariyi tek bir görüntüde toplar.",
    "Michelangelo": "Michelangelo heykeli resme, resmi heykele çevirdi. Bedenin anatomik dramı, ilahi bir tiyatroya dönüşür.",
    "Rembrandt": "Rembrandt yüzü bir manzara olarak inceler. Her kırışık, her gölge bir biyografi.",
    "Diego Velázquez": "Velázquez kraliyetin ressamı olarak çalışırken, gözünü hep saraydaki gerçek hayata, hizmetkârlara çevirdi.",
    "Pieter Bruegel": "Bruegel köylü hayatını mizahla ve şefkatle resmeder. Onun tablolarında halk, devletten daha gerçek.",
    "Henri Rousseau": "Rousseau akademik eğitim almadan resme başladı; tabloları rüyayla naifliğin kesişiminde yaşar.",
    "J.M.W. Turner": "Turner için resim, fırtınanın kendisidir. Önce ışığı, sonra figürü resmetti; modern soyutluğun ilk kıvılcımı.",
    "Caspar David Friedrich": "Friedrich Alman romantizminin en yalnız bakışı. Doğanın karşısında küçülen insan, ama küçülürken yücelen.",
    "Eugène Delacroix": "Delacroix renge tutkunun ressamıdır. Politik dramı, fırçanın enerjisiyle resme aktarır.",
    "Edvard Munch": "Munch bir korkunun ressamıdır. Yüzler, manzaralar, gökyüzü hepsi tek bir titreşimin yansıması.",
    "James Whistler": "Whistler resmi bir armoniye, bir akor dizisine indirgedi. Tablolarına müzik terimleri verdi.",
    "Mary Cassatt": "Cassatt anne-çocuk ilişkisini bir manifesto haline getirdi. Empresyonist çevrenin tek Amerikalı, tek kadın ana figürü.",
    "Frida Kahlo": "Kahlo'nun otoportreleri bedenini, acısını ve politik kimliğini bir görsel günlüğe çevirir.",
    "Andy Warhol": "Warhol popüler kültürü yüksek sanatın diline taşıdı. İmaj çoğaltıldıkça anlamı boşaltıldı.",
    "Piet Mondrian": "Mondrian resmi yatay ve dikeye indirgeyerek spiritüel saflığa ulaşmaya çalıştı.",
    "Gustav Klimt": "Klimt'in altın dönemi. Portre figüründen çok bir ikona dönüşüyor; Bizans aurasından beslenen bir azizlik.",
    "Johannes Vermeer": "Vermeer'in ışığı zamanın kendisi gibi taşıdığı; günlük yaşamın aziz mertebesine yükseldiği bir sessizlik.",
    "Jean-Auguste-Dominique Ingres": "Ingres çizginin ressamıdır. Neoklasik akademinin son büyük temsilcisi.",
    "Hieronymus Bosch": "Bosch ortaçağ hayalgücünün son ve en uç noktası. Cennet, dünya ve cehennem aynı tuval üzerinde."
  };

  function getDesc(artist) {
    if (DESCRIPTIONS[artist]) return DESCRIPTIONS[artist];
    // Bilinmeyen sanatçı için kuratoryel sessiz defaults
    const fallbacks = [
      "Müze koleksiyonundan, kuratoryel seçki kapsamında.",
      "Art Institute of Chicago arşivinden, kamu malı.",
      "Sanat tarihinin sessiz bir dipnotu.",
      "Müzenin kalıcı koleksiyonunda yer alan bir çalışma.",
      "Dönemin estetik araştırmalarından bir kesit."
    ];
    // Sanatçı adının uzunluğuna göre sabit (her zaman aynı sanatçı aynı cümle)
    return fallbacks[artist.length % fallbacks.length];
  }

  function shuffle(arr) {
    const a = [...arr];
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }

  function render() {
    const c = document.getElementById('selectionsContainer');
    if (!c) return;
    
    // Aktif havuz: API'den geldiyse onu, gelmemişse yerel POOL'u kullan
    const activePool = (window.LIVE_POOL && window.LIVE_POOL.length >= 4) ? window.LIVE_POOL : POOL;
    
    c.innerHTML = '';
    const picks = shuffle(activePool).slice(0, 4);
    picks.forEach((art, i) => {
      const reverse = (i % 2 === 1) ? 'reverse' : '';
      const fallback = `${art.title.toUpperCase()}<br><br>${art.artist.toUpperCase()}`;
      
      // Görsel URL kaynağı: API'den geldiyse direkt URL, yerel POOL'dan ise dosya
      const imgSrc = art.imgUrl || `assets/artworks/${art.f}.jpg`;
      
      c.insertAdjacentHTML('beforeend', `
        <div class="selection ${reverse}">
          <div class="selection-image">
            <div class="placeholder">${fallback}</div>
            <img src="${imgSrc}" alt="${art.title}" loading="lazy"
              style="opacity:0;"
              onload="this.style.opacity='1'; const p=this.previousElementSibling; if(p) p.style.display='none';"
              onerror="this.remove();">
          </div>
          <div class="selection-info">
            <div class="number">${String(i+1).padStart(2,'0')} / 04</div>
            <div class="title">${art.title}</div>
            <div class="artist">${art.artist}</div>
            <p class="desc">${getDesc(art.artist)}</p>
            <div class="meta">
              <div class="row"><span class="key">Tarih</span><span class="val">${art.year}</span></div>
              <div class="row"><span class="key">Teknik</span><span class="val">${art.medium}</span></div>
              <div class="row"><span class="key">Olcu</span><span class="val">${art.dims}</span></div>
              <div class="row"><span class="key">Akim</span><span class="val">${art.style}</span></div>
            </div>
            <div class="source">KAYNAK · ${art.museum} · KAMU MALI</div>
          </div>
        </div>
      `);
    });
  }
  
  // ============================================================
  // ART INSTITUTE OF CHICAGO API — 60 eser canlı çekiliyor
  // ============================================================
  async function loadLiveArtworks() {
    try {
      // 100 eser iste, görseli olanları filtrele, 60'a düşür
      const apiUrl = 'https://api.artic.edu/api/v1/artworks/search?q=painting&limit=100&fields=id,title,artist_display,date_display,medium_display,dimensions,image_id,style_title,classification_title,place_of_origin';
      const response = await fetch(apiUrl);
      if (!response.ok) throw new Error('API hatası');
      const data = await response.json();
      
      if (!data.data || !Array.isArray(data.data)) throw new Error('Geçersiz veri');
      
      // image_id olanları filtrele, formatla
      const validArts = data.data
        .filter(a => a.image_id) // sadece görseli olanlar
        .map(a => {
          // Artist display'ten temiz isim çıkar (ilk satır)
          const artist = (a.artist_display || 'BİLİNMİYOR')
            .split('\n')[0]
            .replace(/\(.*$/, '') // parantez içini kaldır
            .trim()
            .toUpperCase();
          
          return {
            f: a.image_id,
            imgUrl: `https://www.artic.edu/iiif/2/${a.image_id}/full/843,/0/default.jpg`,
            title: (a.title || 'İSİMSİZ').toUpperCase(),
            artist: artist,
            year: a.date_display || '—',
            medium: (a.medium_display || a.classification_title || '—').split(',')[0].trim(),
            dims: a.dimensions ? a.dimensions.split(';')[0].split('(')[0].trim() : '—',
            style: a.style_title || a.classification_title || a.place_of_origin || '—',
            museum: 'ART INSTITUTE OF CHICAGO'
          };
        })
        .slice(0, 60);
      
      if (validArts.length >= 4) {
        window.LIVE_POOL = validArts;
        // Render'ı yeniden çağır - canlı verilerle
        render();
      }
    } catch (err) {
      // API başarısız - yerel POOL kullanılacak (zaten render edilmiş)
      console.warn('Canlı eser yüklenemedi, yerel havuz kullanılıyor:', err.message);
    }
  }

  document.getElementById('shuffleBtn').addEventListener('click', render);
  render(); // İlk render - yerel POOL ile (anında görünür)
  loadLiveArtworks(); // Arka planda canlı eserleri yükle - geldiğinde re-render
  
  // ============================================================
  // SHOPIFY SEPET SAYISI - sayfa açılışta güncelle
  // ============================================================
  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      if (!res.ok) return;
      const cart = await res.json();
      const badge = document.getElementById('cartCount');
      if (badge && cart.item_count !== undefined) {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
      }
    } catch (err) {
      // Shopify ortamı değil — sepet yok, sessizce geç
    }
  }
  updateCartCount();

  // ============================================================
  // 360° SANAL TUR — 3 mekân için modal popup
  // ============================================================
  // KURULUM:
  // Mekanları Insta360/360° kamera ile çek → Marzipano ile birleştir
  // → Netlify'a yükle → buradaki URL'leri yapıştır
  // ============================================================
  const TOUR_URLS = {
    'stage':    '', // örn: 'https://jul-stage-tour.netlify.app/'
    'studio-a': '', // örn: 'https://jul-studio-a.netlify.app/'
    'studio-b': ''  // örn: 'https://jul-studio-b.netlify.app/'
  };
  
  const TOUR_ROOM_NAMES = {
    'stage':    'STAGE · 50 M²',
    'studio-a': 'STUDIO A · ÇEKİM ODASI',
    'studio-b': 'STUDIO B · SELF TAPING & SES KAYIT'
  };
  
  // FOTOĞRAF GALERİSİ - 360 URL yokken gösterilecek
  const GALLERY_PHOTOS = {
    'stage': [
      julAsset('stage-01.jpg'),
      julAsset('stage-02.jpg'),
      julAsset('stage-03.jpg')
    ],
    'studio-a': [
      julAsset('studio-a-01.jpg'),
      julAsset('studio-a-02.jpg'),
      julAsset('studio-a-03.jpg'),
      julAsset('studio-a-04.jpg')
    ],
    'studio-b': [
      julAsset('studio-b-01.jpg'),
      julAsset('studio-b-02.jpg'),
      julAsset('studio-b-03.jpg'),
      julAsset('studio-b-04.jpg')
    ]
  };
  
  const tourModal = document.getElementById('tour-modal');
  const tourIframe = document.getElementById('tour-iframe');
  const tourClose = document.getElementById('tourClose');
  const tourModalRoom = document.getElementById('tourModalRoom');
  
  // Galery DOM
  const galleryModal = document.getElementById('gallery-modal');
  const galleryImage = document.getElementById('galleryImage');
  const galleryThumbs = document.getElementById('galleryThumbs');
  const galleryModalRoom = document.getElementById('galleryModalRoom');
  const galleryCurrent = document.getElementById('galleryCurrent');
  const galleryTotal = document.getElementById('galleryTotal');
  const galleryClose = document.getElementById('galleryClose');
  const galleryPrev = document.getElementById('galleryPrev');
  const galleryNext = document.getElementById('galleryNext');
  
  let GALLERY_STATE = {
    photos: [],
    index: 0,
    roomKey: ''
  };
  
  function openGallery(roomKey, startIndex) {
    const photos = GALLERY_PHOTOS[roomKey] || [];
    if (photos.length === 0) {
      // Fotoğraf da yok, WhatsApp fallback
      const msg = `Bu mekanın fotoğrafları yakında. WhatsApp ile bilgi alabilirsiniz.`;
      if (confirm(msg + '\n\nWhatsApp ile iletişime geçmek ister misiniz?')) {
        window.open(`https://wa.me/905318297585?text=${encodeURIComponent('Merhaba, ' + (TOUR_ROOM_NAMES[roomKey] || 'JUL Art House mekânı') + ' fotoğrafları hakkında bilgi almak istiyorum.')}`, '_blank');
      }
      return;
    }
    
    GALLERY_STATE.photos = photos;
    GALLERY_STATE.index = (typeof startIndex === 'number' && startIndex >= 0 && startIndex < photos.length) ? startIndex : 0;
    GALLERY_STATE.roomKey = roomKey;
    
    if (galleryModalRoom) galleryModalRoom.textContent = TOUR_ROOM_NAMES[roomKey] || roomKey.toUpperCase();
    if (galleryTotal) galleryTotal.textContent = photos.length;
    
    // Thumbnail strip'i oluştur
    if (galleryThumbs) {
      galleryThumbs.innerHTML = '';
      photos.forEach((src, i) => {
        galleryThumbs.insertAdjacentHTML('beforeend', `
          <div class="gallery-thumb" data-index="${i}">
            <img src="${src}" alt="">
          </div>
        `);
      });
      galleryThumbs.querySelectorAll('.gallery-thumb').forEach(thumb => {
        thumb.addEventListener('click', () => showGalleryPhoto(parseInt(thumb.dataset.index)));
      });
    }
    
    showGalleryPhoto(GALLERY_STATE.index);
    
    galleryModal.classList.add('active');
    galleryModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  
  function showGalleryPhoto(index) {
    const photos = GALLERY_STATE.photos;
    if (!photos.length) return;
    if (index < 0) index = photos.length - 1;
    if (index >= photos.length) index = 0;
    GALLERY_STATE.index = index;
    
    if (galleryImage) {
      galleryImage.classList.add('loading');
      const newImg = new Image();
      newImg.onload = () => {
        galleryImage.src = photos[index];
        galleryImage.classList.remove('loading');
      };
      newImg.src = photos[index];
    }
    if (galleryCurrent) galleryCurrent.textContent = index + 1;
    
    // Active thumbnail
    if (galleryThumbs) {
      galleryThumbs.querySelectorAll('.gallery-thumb').forEach((t, i) => {
        t.classList.toggle('active', i === index);
      });
      // Active thumb'a scroll
      const activeThumb = galleryThumbs.querySelector(`.gallery-thumb[data-index="${index}"]`);
      if (activeThumb) activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }
  
  function closeGallery() {
    if (galleryModal) {
      galleryModal.classList.remove('active');
      galleryModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  }
  
  // Navigation
  if (galleryPrev) galleryPrev.addEventListener('click', () => showGalleryPhoto(GALLERY_STATE.index - 1));
  if (galleryNext) galleryNext.addEventListener('click', () => showGalleryPhoto(GALLERY_STATE.index + 1));
  if (galleryClose) galleryClose.addEventListener('click', closeGallery);
  
  // Keyboard
  document.addEventListener('keydown', (e) => {
    if (!galleryModal || !galleryModal.classList.contains('active')) return;
    if (e.key === 'Escape') closeGallery();
    if (e.key === 'ArrowLeft') showGalleryPhoto(GALLERY_STATE.index - 1);
    if (e.key === 'ArrowRight') showGalleryPhoto(GALLERY_STATE.index + 1);
  });
  
  // Touch swipe
  let touchStartX = 0;
  if (galleryModal) {
    galleryModal.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    galleryModal.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 50) {
        if (dx > 0) showGalleryPhoto(GALLERY_STATE.index - 1);
        else showGalleryPhoto(GALLERY_STATE.index + 1);
      }
    }, { passive: true });
  }
  
  function openTour(roomKey) {
    const url = TOUR_URLS[roomKey];
    // 360 URL'i varsa → 360 tur aç, yoksa → fotoğraf galerisi aç
    if (!url) {
      openGallery(roomKey);
      return;
    }
    tourIframe.src = url;
    tourModalRoom.textContent = TOUR_ROOM_NAMES[roomKey] || roomKey.toUpperCase();
    tourModal.classList.add('active');
    tourModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  
  function closeTour() {
    tourModal.classList.remove('active');
    tourModal.setAttribute('aria-hidden', 'true');
    tourIframe.src = ''; // iframe'i durdur
    document.body.style.overflow = '';
  }
  
  // MEKANI GEZ butonlarına tıklama
  document.querySelectorAll('.tour-button[data-tour]').forEach(btn => {
    btn.addEventListener('click', () => {
      openTour(btn.dataset.tour);
    });
  });
  
  // Inline venue-photo'lara tıklayınca lightbox aç
  document.querySelectorAll('.venue-editorial').forEach(gallery => {
    const roomKey = gallery.dataset.room;
    if (!roomKey) return;
    gallery.querySelectorAll('.ve-photo').forEach(photo => {
      photo.addEventListener('click', () => {
        const startIndex = parseInt(photo.dataset.photo || '0');
        openGallery(roomKey, startIndex);
      });
    });
  });
  
  // Kapat butonu
  if (tourClose) tourClose.addEventListener('click', closeTour);
  
  // ESC tuşuyla kapat
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && tourModal.classList.contains('active')) closeTour();
  });

  // ============================================================
  // TAKVIM / CALENDAR — Google Calendar iCal Entegrasyonu
  // ============================================================
  // KURULUM:
  // 1. Google Calendar'a git: https://calendar.google.com
  // 2. Sol menüde "Takvimlerim" → JUL takvimini bul → 3 nokta → Ayarlar
  // 3. "Erişim İzinleri" → "Herkese açık hale getir" ✓
  // 4. "Takvimi entegre et" bölümünde "Genel iCal biçiminde adres"i kopyala
  // 5. URL'i şuraya yapıştır:
  const GOOGLE_CALENDAR_ICAL_URL = 'https://calendar.google.com/calendar/ical/arthouse%40julcreative.com.tr/public/basic.ics'; 
  // Örnek: 'https://calendar.google.com/calendar/ical/your-email%40gmail.com/public/basic.ics'
  // ============================================================
  
  // Birden fazla CORS proxy - biri çalışmazsa diğeri denenir
  const CORS_PROXIES = [
    'https://corsproxy.io/?url=',
    'https://api.allorigins.win/raw?url=',
    'https://api.codetabs.com/v1/proxy?quest=',
    'https://thingproxy.freeboard.io/fetch/'
  ];
  
  // LOKAL ETKINLIKLER — JUL'un kendi atolye programi
  // Google Calendar bagimsiz, her durumda takvimde gozukur
  const LOCAL_EVENTS = {
    // CEREN KOÇ — MEISNER & STANISLAVSKI ATÖLYESİ
    '2026-06-12': [{ title: 'CEREN KOÇ — TANIŞMA WORKSHOPU (ÜCRETSİZ)', time: '19:30', location: 'JUL Art House — Beyoğlu' }],
    '2026-06-20': [{ title: 'CEREN KOÇ — MEISNER ATÖLYESİ / 01. DERS', time: '16:00', location: 'JUL Art House — Beyoğlu' }],
    '2026-06-24': [{ title: 'CEREN KOÇ — MEISNER ATÖLYESİ / 02. DERS', time: '19:00', location: 'JUL Art House — Beyoğlu' }],
    '2026-06-28': [
      { title: 'ÖYKÜSU ÖZYÜREK — ESKİ İSTANBUL\'DA KÂŞİFLER / 02. GÜN', time: '12:00', location: 'JUL Art House — Beyoğlu' },
      { title: 'CEREN KOÇ — MEISNER ATÖLYESİ / 03. DERS', time: '17:00', location: 'JUL Art House — Beyoğlu' }
    ],
    '2026-07-01': [{ title: 'CEREN KOÇ — MEISNER ATÖLYESİ / 04. DERS', time: '19:00', location: 'JUL Art House — Beyoğlu' }],
    '2026-07-04': [{ title: 'CEREN KOÇ — MEISNER ATÖLYESİ / 05. DERS', time: '16:00', location: 'JUL Art House — Beyoğlu' }],
    // ÖYKÜSU ÖZYÜREK — ESKİ İSTANBUL'DA KÂŞİFLER
    '2026-06-27': [{ title: 'ÖYKÜSU ÖZYÜREK — ESKİ İSTANBUL\'DA KÂŞİFLER / 01. GÜN', time: '12:00', location: 'JUL Art House — Beyoğlu' }],
    // CEREN ATMACA — İMGENİN İZİNDE (SANAT TERAPİSİ)
    '2026-06-21': [{ title: 'CEREN ATMACA — İMGENİN İZİNDE (SANAT TERAPİSİ)', time: '17:00', location: 'JUL Art House — Beyoğlu' }]
  };
  
  // Iki kaynagi birlestir (lokal + Google Calendar remote)
  function mergeEvents(remoteEvents) {
    const merged = {};
    for (const [key, events] of Object.entries(LOCAL_EVENTS)) {
      merged[key] = [...events];
    }
    for (const [key, events] of Object.entries(remoteEvents || {})) {
      if (merged[key]) {
        merged[key] = [...merged[key], ...events];
      } else {
        merged[key] = [...events];
      }
    }
    return merged;
  }
  
  const CALENDAR_STATE = {
    currentDate: new Date(),
    events: { ...LOCAL_EVENTS },
    loaded: false
  };
  
  const TR_MONTHS = ['OCAK','ŞUBAT','MART','NİSAN','MAYIS','HAZİRAN','TEMMUZ','AĞUSTOS','EYLÜL','EKİM','KASIM','ARALIK'];
  const TR_DAYS_SHORT = ['PZT','SAL','ÇAR','PER','CUM','CMT','PAZ'];
  const TR_DAYS_FULL = ['PAZARTESİ','SALI','ÇARŞAMBA','PERŞEMBE','CUMA','CUMARTESİ','PAZAR'];
  
  // iCal parser
  function parseICalendar(icsText) {
    const events = {};
    const lines = icsText.replace(/\r\n /g, '').replace(/\r\n\t/g, '').split(/\r?\n/);
    let currentEvent = null;
    
    for (const line of lines) {
      if (line === 'BEGIN:VEVENT') {
        currentEvent = {};
      } else if (line === 'END:VEVENT' && currentEvent) {
        if (currentEvent.start) {
          const dateKey = currentEvent.start.substring(0, 10);
          if (!events[dateKey]) events[dateKey] = [];
          events[dateKey].push(currentEvent);
        }
        currentEvent = null;
      } else if (currentEvent) {
        if (line.startsWith('SUMMARY')) {
          currentEvent.title = line.substring(line.indexOf(':')+1).trim();
        } else if (line.startsWith('DTSTART')) {
          const val = line.substring(line.indexOf(':')+1).trim();
          if (val.length >= 8) {
            const y = val.substring(0,4), m = val.substring(4,6), d = val.substring(6,8);
            currentEvent.start = `${y}-${m}-${d}`;
            if (val.length >= 15 && val[8] === 'T') {
              const hh = val.substring(9,11), mm = val.substring(11,13);
              currentEvent.time = `${hh}:${mm}`;
            }
          }
        } else if (line.startsWith('LOCATION')) {
          currentEvent.location = line.substring(line.indexOf(':')+1).trim();
        } else if (line.startsWith('DESCRIPTION')) {
          currentEvent.desc = line.substring(line.indexOf(':')+1).trim();
        }
      }
    }
    return events;
  }
  
  // İçeriği iCal mi kontrol et
  function looksLikeICal(text) {
    return text && text.indexOf('BEGIN:VCALENDAR') !== -1;
  }
  
  // Tüm proxy'leri sırayla dene
  async function fetchICalWithFallback(icalUrl) {
    let lastError = null;
    for (let i = 0; i < CORS_PROXIES.length; i++) {
      const proxy = CORS_PROXIES[i];
      try {
        const proxyUrl = proxy + encodeURIComponent(icalUrl);
        console.log(`[JUL Takvim] Proxy ${i+1}/${CORS_PROXIES.length} deneniyor:`, proxy.split('?')[0]);
        const res = await fetch(proxyUrl);
        if (!res.ok) {
          throw new Error(`HTTP ${res.status}`);
        }
        const text = await res.text();
        if (!looksLikeICal(text)) {
          throw new Error('iCal formatı değil — takvim public DEĞİL veya boş');
        }
        console.log(`[JUL Takvim] ✓ Başarılı (proxy ${i+1})`);
        return text;
      } catch (err) {
        lastError = err;
        console.warn(`[JUL Takvim] Proxy ${i+1} başarısız:`, err.message);
      }
    }
    throw lastError || new Error('Tüm proxy denemeleri başarısız');
  }
  
  async function loadCalendarEvents() {
    if (!GOOGLE_CALENDAR_ICAL_URL) {
      console.warn('[JUL Takvim] iCal URL girilmedi. Sadece lokal etkinlikler gosteriliyor.');
      CALENDAR_STATE.events = mergeEvents({});
      renderCalendar();
      return;
    }
    try {
      const icsText = await fetchICalWithFallback(GOOGLE_CALENDAR_ICAL_URL);
      const remoteEvents = parseICalendar(icsText);
      CALENDAR_STATE.events = mergeEvents(remoteEvents);
      CALENDAR_STATE.loaded = true;
      const eventDays = Object.keys(CALENDAR_STATE.events).length;
      const totalEvents = Object.values(CALENDAR_STATE.events).reduce((a, e) => a + e.length, 0);
      console.log(`[JUL Takvim] ✓ ${eventDays} gun, ${totalEvents} etkinlik (lokal + Google)`);
      renderCalendar();
    } catch (err) {
      console.error('[JUL Takvim] ✗ Google Calendar yuklenemedi:', err.message);
      console.error('[JUL Takvim] Lokal etkinlikler hala gozukur.');
      CALENDAR_STATE.events = mergeEvents({});
      renderCalendar();
    }
  }
  
  function fmtDateKey(year, month, day) {
    return `${year}-${String(month+1).padStart(2,'0')}-${String(day).padStart(2,'0')}`;
  }
  
  function renderCalendar() {
    // Hem section hem modal'a render et
    renderCalendarInto('calendarGrid', 'calMonthName', 'modal');
    renderCalendarInto('calendarSectionGrid', 'calSecMonthName', 'section');
  }
  
  function renderCalendarInto(gridId, monthNameId, variant) {
    const grid = document.getElementById(gridId);
    const monthName = document.getElementById(monthNameId);
    if (!grid || !monthName) return;
    
    const d = CALENDAR_STATE.currentDate;
    const year = d.getFullYear();
    const month = d.getMonth();
    
    monthName.textContent = `${TR_MONTHS[month]} ${year}`;
    
    grid.innerHTML = '';
    
    // Gün başlıkları (Pzt-Paz)
    TR_DAYS_SHORT.forEach(day => {
      grid.insertAdjacentHTML('beforeend', `<div class="calendar-day-header">${day}</div>`);
    });
    
    // Ay başlangıcı: hangi gün
    const firstDay = new Date(year, month, 1);
    let startDay = firstDay.getDay() - 1; // 0=Pzr, biz Pzt'den başlatıyoruz
    if (startDay < 0) startDay = 6; // Pazar'sa son sütuna
    
    // Önceki ayın son günleri
    const prevMonthLast = new Date(year, month, 0).getDate();
    for (let i = startDay - 1; i >= 0; i--) {
      grid.insertAdjacentHTML('beforeend', `
        <div class="calendar-day other-month">
          <span class="day-number">${prevMonthLast - i}</span>
        </div>
      `);
    }
    
    // Bu ayın günleri
    const daysInMonth = new Date(year, month+1, 0).getDate();
    const today = new Date();
    const todayKey = fmtDateKey(today.getFullYear(), today.getMonth(), today.getDate());
    
    for (let day = 1; day <= daysInMonth; day++) {
      const dateKey = fmtDateKey(year, month, day);
      const isToday = dateKey === todayKey;
      const events = CALENDAR_STATE.events[dateKey] || [];
      const hasEvent = events.length > 0;
      
      const classes = ['calendar-day'];
      if (isToday) classes.push('today');
      if (hasEvent) classes.push('has-event');
      
      const miniHTML = events.length > 0 
        ? `<div class="day-events-mini">${events.slice(0,1).map(e => e.title).join(', ')}${events.length > 1 ? ` +${events.length-1}` : ''}</div>`
        : '';
      
      grid.insertAdjacentHTML('beforeend', `
        <div class="${classes.join(' ')}" data-date="${dateKey}">
          <span class="day-number">${day}</span>
          ${miniHTML}
          ${hasEvent ? '<span class="day-dot"></span>' : ''}
        </div>
      `);
    }
    
    // Sonraki ayın ilk günleri
    const totalCells = grid.querySelectorAll('.calendar-day, .calendar-day-header').length - 7;
    const remainingCells = (7 - (totalCells % 7)) % 7;
    for (let i = 1; i <= remainingCells; i++) {
      grid.insertAdjacentHTML('beforeend', `
        <div class="calendar-day other-month">
          <span class="day-number">${i}</span>
        </div>
      `);
    }
    
    // Tıklama eventleri
    grid.querySelectorAll('.calendar-day:not(.other-month)').forEach(cell => {
      cell.addEventListener('click', () => {
        showDayDetail(cell.dataset.date, variant);
      });
    });
  }
  
  function showDayDetail(dateKey, variant) {
    variant = variant || 'modal';
    const detailId = variant === 'section' ? 'calendarSectionDetail' : 'calendarDetail';
    const dateId   = variant === 'section' ? 'cdSecDate' : 'cdDate';
    const eventsId = variant === 'section' ? 'cdSecEvents' : 'cdEvents';
    
    const detail = document.getElementById(detailId);
    const dateEl = document.getElementById(dateId);
    const eventsEl = document.getElementById(eventsId);
    if (!detail) return;
    
    const events = CALENDAR_STATE.events[dateKey] || [];
    const [y,m,d] = dateKey.split('-').map(Number);
    const dateObj = new Date(y, m-1, d);
    const dayOfWeek = dateObj.getDay() === 0 ? 6 : dateObj.getDay() - 1;
    
    dateEl.textContent = `${d} ${TR_MONTHS[m-1]} ${y} · ${TR_DAYS_FULL[dayOfWeek]}`;
    
    if (events.length === 0) {
      eventsEl.innerHTML = '<div class="cd-empty">◆ BU GUNDE PLANLI ETKINLIK YOK</div>';
    } else {
      eventsEl.innerHTML = events.map(e => `
        <div class="cd-event">
          ${e.time ? `<div class="cd-event-time">${e.time}</div>` : ''}
          <div class="cd-event-title">${e.title || 'ETKINLIK'}</div>
          ${e.location ? `<div class="cd-event-loc">${e.location}</div>` : ''}
        </div>
      `).join('');
    }
    
    detail.classList.add('active');
    detail.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
  
  // Ay navigasyonu - modal
  document.getElementById('calPrev')?.addEventListener('click', () => {
    CALENDAR_STATE.currentDate = new Date(CALENDAR_STATE.currentDate.getFullYear(), CALENDAR_STATE.currentDate.getMonth() - 1, 1);
    renderCalendar();
  });
  document.getElementById('calNext')?.addEventListener('click', () => {
    CALENDAR_STATE.currentDate = new Date(CALENDAR_STATE.currentDate.getFullYear(), CALENDAR_STATE.currentDate.getMonth() + 1, 1);
    renderCalendar();
  });
  document.getElementById('cdClose')?.addEventListener('click', () => {
    document.getElementById('calendarDetail').classList.remove('active');
  });
  
  // Ay navigasyonu - section (anasayfa)
  document.getElementById('calSecPrev')?.addEventListener('click', () => {
    CALENDAR_STATE.currentDate = new Date(CALENDAR_STATE.currentDate.getFullYear(), CALENDAR_STATE.currentDate.getMonth() - 1, 1);
    renderCalendar();
  });
  document.getElementById('calSecNext')?.addEventListener('click', () => {
    CALENDAR_STATE.currentDate = new Date(CALENDAR_STATE.currentDate.getFullYear(), CALENDAR_STATE.currentDate.getMonth() + 1, 1);
    renderCalendar();
  });
  document.getElementById('cdSecClose')?.addEventListener('click', () => {
    document.getElementById('calendarSectionDetail').classList.remove('active');
  });
  
  // İlk yükleme
  renderCalendar();
  loadCalendarEvents();

  // ============================================================
  // SHOP — ÜRÜN HAVUZU + 3D OBJE RENDERLAYICI (Three.js)
  // ============================================================
  // SHOP ÜRÜNLERİ — TAMAMEN SHOPIFY ÜZERİNDEN YÖNETİLİR
  // Bu dizi boş, gerçek ürünler window.SHOPIFY_PRODUCTS.shop'tan gelir
  const PRODUCTS = [];


  // 3D obje render — Three.js
  const threeScenes = []; // Cleanup için
  
  function render3DObject(canvas, shape) {
    if (typeof THREE === 'undefined') return false;
    
    const w = canvas.clientWidth || 300;
    const h = canvas.clientHeight || 300;
    
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(40, w/h, 0.1, 100);
    camera.position.set(2.5, 2, 3.5);
    camera.lookAt(0, 0, 0);
    
    const renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true });
    renderer.setSize(w, h, false);
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setClearColor(0xf0ede8, 1);
    
    // Lights — JUL atmosferi
    const amb = new THREE.AmbientLight(0xffffff, 0.55);
    scene.add(amb);
    const key = new THREE.DirectionalLight(0xffffff, 0.7);
    key.position.set(3, 5, 4);
    scene.add(key);
    const rim = new THREE.DirectionalLight(0xC8FF3E, 0.18);
    rim.position.set(-3, 2, -2);
    scene.add(rim);
    
    // Zemin gölgesi efekti
    const groundGeo = new THREE.CircleGeometry(2, 32);
    const groundMat = new THREE.MeshBasicMaterial({ color: 0x000000, opacity: 0.06, transparent: true });
    const ground = new THREE.Mesh(groundGeo, groundMat);
    ground.rotation.x = -Math.PI / 2;
    ground.position.y = -0.85;
    scene.add(ground);
    
    let mesh;
    const mat = new THREE.MeshStandardMaterial({ 
      color: 0x1a1a1a, 
      roughness: 0.55, 
      metalness: 0.15 
    });
    
    if (shape === 'archway') {
      // Çatı / kemer formu
      const group = new THREE.Group();
      const archGeo = new THREE.TorusGeometry(0.7, 0.18, 16, 32, Math.PI);
      const arch = new THREE.Mesh(archGeo, mat);
      arch.position.y = 0;
      group.add(arch);
      // Kolonlar
      const colGeo = new THREE.CylinderGeometry(0.18, 0.18, 0.8, 16);
      const colL = new THREE.Mesh(colGeo, mat);
      colL.position.set(-0.7, -0.4, 0);
      const colR = new THREE.Mesh(colGeo, mat);
      colR.position.set(0.7, -0.4, 0);
      group.add(colL, colR);
      mesh = group;
    } else if (shape === 'chair') {
      // Modüler sandalye — 3 parça
      const group = new THREE.Group();
      const seat = new THREE.Mesh(
        new THREE.BoxGeometry(1.2, 0.12, 1.0),
        new THREE.MeshStandardMaterial({ color: 0xC8FF3E, roughness: 0.4 })
      );
      seat.position.y = 0;
      group.add(seat);
      const back = new THREE.Mesh(
        new THREE.BoxGeometry(1.2, 1.0, 0.12),
        mat
      );
      back.position.set(0, 0.5, -0.4);
      group.add(back);
      const base = new THREE.Mesh(
        new THREE.BoxGeometry(1.0, 0.8, 0.9),
        new THREE.MeshStandardMaterial({ color: 0x2a2a2a, roughness: 0.6 })
      );
      base.position.y = -0.5;
      group.add(base);
      mesh = group;
    } else if (shape === 'totem') {
      // Totem — istiflenmiş geometriler
      const group = new THREE.Group();
      const cube = new THREE.Mesh(new THREE.BoxGeometry(0.7, 0.5, 0.7), 
        new THREE.MeshStandardMaterial({ color: 0xf4f2ee, roughness: 0.5 }));
      cube.position.y = -0.7;
      const sphere = new THREE.Mesh(new THREE.SphereGeometry(0.4, 32, 32), 
        new THREE.MeshStandardMaterial({ color: 0x1a1a1a, roughness: 0.3 }));
      sphere.position.y = -0.15;
      const cyl = new THREE.Mesh(new THREE.CylinderGeometry(0.25, 0.35, 0.6, 32), 
        new THREE.MeshStandardMaterial({ color: 0xC8FF3E, roughness: 0.4 }));
      cyl.position.y = 0.5;
      const cone = new THREE.Mesh(new THREE.ConeGeometry(0.22, 0.45, 32), 
        new THREE.MeshStandardMaterial({ color: 0xf4f2ee, roughness: 0.5 }));
      cone.position.y = 1.0;
      group.add(cube, sphere, cyl, cone);
      mesh = group;
    } else if (shape === 'vase') {
      // Vazo — lathe geometry ile
      const points = [];
      for (let i = 0; i <= 20; i++) {
        const t = i / 20;
        const y = t * 1.6 - 0.8;
        const r = 0.3 + Math.sin(t * Math.PI * 1.5) * 0.25 + 0.15;
        points.push(new THREE.Vector2(Math.abs(r), y));
      }
      const vaseGeo = new THREE.LatheGeometry(points, 64);
      mesh = new THREE.Mesh(vaseGeo, new THREE.MeshStandardMaterial({ 
        color: 0xa85a3a, roughness: 0.7, metalness: 0.05 
      }));
    } else if (shape === 'bowl') {
      // Çanak — lathe
      const points = [];
      for (let i = 0; i <= 15; i++) {
        const t = i / 15;
        const y = t * 0.7 - 0.35;
        const r = 0.2 + t * 0.6;
        points.push(new THREE.Vector2(r, y));
      }
      const bowlGeo = new THREE.LatheGeometry(points, 48);
      mesh = new THREE.Mesh(bowlGeo, new THREE.MeshStandardMaterial({ 
        color: 0x3a3a3a, roughness: 0.45, metalness: 0.2 
      }));
    } else if (shape === 'plate') {
      // Düz tabak
      const group = new THREE.Group();
      const plate = new THREE.Mesh(
        new THREE.CylinderGeometry(1.0, 0.95, 0.08, 64),
        new THREE.MeshStandardMaterial({ color: 0xf4f2ee, roughness: 0.3, metalness: 0.1 })
      );
      group.add(plate);
      // Çatlak efekti — lime hat
      const crack = new THREE.Mesh(
        new THREE.BoxGeometry(1.4, 0.085, 0.04),
        new THREE.MeshStandardMaterial({ color: 0xC8FF3E, roughness: 0.4 })
      );
      crack.position.y = 0.001;
      crack.rotation.y = Math.PI / 6;
      group.add(crack);
      group.rotation.x = 0.3;
      mesh = group;
    }
    
    if (mesh) {
      scene.add(mesh);
      // Yavaş dönüş animasyonu
      const animate = () => {
        if (!canvas.isConnected) return; // DOM'dan kaldırıldıysa dur
        mesh.rotation.y += 0.005;
        renderer.render(scene, camera);
        requestAnimationFrame(animate);
      };
      animate();
    }
    
    threeScenes.push({ scene, renderer, canvas });
    return true;
  }
  
  // SVG fallback / 2D ürün görselleri
  function renderProductSVG(shape) {
    const svgs = {
      'print-typo': `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
        <rect width="200" height="200" fill="#F4F2EE"/>
        <rect x="20" y="20" width="160" height="160" fill="none" stroke="#0A0A0A" stroke-width="1.5"/>
        <text x="100" y="115" text-anchor="middle" font-family="Helvetica" font-weight="900" font-size="80" fill="#0A0A0A" letter-spacing="-3">03</text>
        <text x="100" y="140" text-anchor="middle" font-family="Helvetica" font-size="8" letter-spacing="2" fill="#0A0A0A">ARSIV</text>
        <circle cx="170" cy="30" r="6" fill="#C8FF3E"/>
      </svg>`,
      'print-photo': `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
        <rect width="200" height="200" fill="#2a2a2a"/>
        <rect x="30" y="40" width="140" height="100" fill="#1a1a1a"/>
        <circle cx="100" cy="90" r="20" fill="#5a5a5a" opacity="0.6"/>
        <rect x="30" y="40" width="140" height="100" fill="none" stroke="#f4f2ee" stroke-width="0.5" opacity="0.3"/>
        <text x="30" y="165" font-family="Helvetica" font-size="7" letter-spacing="2" fill="#f4f2ee">KARANLIK ODA · 01</text>
      </svg>`,
      'print-blue': `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
        <rect width="200" height="200" fill="#F4F2EE"/>
        <line x1="20" y1="40" x2="180" y2="40" stroke="#1a3a8a" stroke-width="14"/>
        <line x1="20" y1="80" x2="180" y2="80" stroke="#1a3a8a" stroke-width="8"/>
        <line x1="20" y1="110" x2="120" y2="110" stroke="#1a3a8a" stroke-width="20"/>
        <line x1="20" y1="150" x2="180" y2="150" stroke="#0A0A0A" stroke-width="2"/>
        <text x="20" y="180" font-family="Helvetica" font-weight="900" font-size="11" letter-spacing="2">MAVI HAT</text>
      </svg>`,
      'tote': `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
        <rect width="200" height="200" fill="#E8E0D2"/>
        <path d="M 60 70 L 60 170 L 140 170 L 140 70 Z" fill="#D4C8B0" stroke="#0A0A0A" stroke-width="1.5"/>
        <path d="M 75 70 Q 75 45 100 45 Q 125 45 125 70" fill="none" stroke="#0A0A0A" stroke-width="3"/>
        <text x="100" y="125" text-anchor="middle" font-family="Helvetica" font-weight="900" font-size="22" letter-spacing="2">JUL</text>
        <circle cx="100" cy="140" r="3" fill="#C8FF3E"/>
      </svg>`,
      'tshirt': `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
        <rect width="200" height="200" fill="#f0ede8"/>
        <path d="M 60 50 L 50 70 L 60 80 L 70 70 L 70 160 L 130 160 L 130 70 L 140 70 L 150 70 L 140 50 L 120 50 Q 110 60 100 60 Q 90 60 80 50 Z" fill="#1a1a1a" stroke="#0A0A0A" stroke-width="1.5"/>
        <text x="100" y="115" text-anchor="middle" font-family="Helvetica" font-weight="900" font-size="14" letter-spacing="2" fill="#C8FF3E">CATI</text>
      </svg>`,
      'book': `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
        <rect width="200" height="200" fill="#f0ede8"/>
        <rect x="55" y="35" width="90" height="130" fill="#0A0A0A"/>
        <rect x="50" y="30" width="90" height="130" fill="#F4F2EE" stroke="#0A0A0A" stroke-width="1"/>
        <text x="60" y="60" font-family="Helvetica" font-weight="900" font-size="22" letter-spacing="-1">JUL</text>
        <text x="60" y="78" font-family="Helvetica" font-size="9" letter-spacing="2">YIL 01</text>
        <rect x="60" y="140" width="20" height="3" fill="#C8FF3E"/>
        <text x="60" y="155" font-family="Helvetica" font-size="6" letter-spacing="1.5">YAYIN · 2024</text>
      </svg>`
    };
    return svgs[shape] || svgs['print-typo'];
  }

  function renderShop(filter = 'all') {
    const grid = document.getElementById('shopGrid');
    if (!grid) return;
    grid.innerHTML = '';
    
    // SADECE Shopify'dan gelen ürünleri göster
    const shopifyProducts = (window.SHOPIFY_PRODUCTS && window.SHOPIFY_PRODUCTS.shop) || [];
    
    // Hiç ürün yok → "Yakında" mesajı
    if (shopifyProducts.length === 0) {
      grid.innerHTML = `
        <div style="grid-column:1/-1;padding:80px 40px;text-align:center;background:rgba(10,10,10,0.04);">
          <div style="font-size:11px;letter-spacing:0.3em;text-transform:uppercase;color:rgba(10,10,10,0.4);margin-bottom:20px;">◆</div>
          <div style="font-size:24px;font-weight:900;letter-spacing:-0.02em;text-transform:uppercase;margin-bottom:14px;">ÜRÜNLER YAKINDA</div>
          <div style="font-size:12px;letter-spacing:0.2em;text-transform:uppercase;color:rgba(10,10,10,0.55);max-width:480px;margin:0 auto;line-height:1.6;">
            JUL Art House sanatçılarının üretimleri, edisyonlar ve mekan ürünleri yakında burada.
          </div>
          <a href="https://www.instagram.com/jularthouse/" target="_blank" rel="noopener" style="display:inline-block;margin-top:30px;padding:12px 24px;background:#0A0A0A;color:#F4F2EE;text-decoration:none;font-size:10px;letter-spacing:0.25em;font-weight:700;text-transform:uppercase;">INSTAGRAM'DA TAKIP ET →</a>
        </div>
      `;
      return;
    }
    
    // Filtreleme
    const filtered = filter === 'all' 
      ? shopifyProducts 
      : shopifyProducts.filter(p => (p.category || '').toLowerCase() === filter.toLowerCase());
    
    if (filtered.length === 0) {
      grid.innerHTML = `<div style="grid-column:1/-1;padding:60px;text-align:center;font-size:11px;letter-spacing:0.2em;text-transform:uppercase;color:rgba(10,10,10,0.5);">Bu kategoride henüz ürün yok.</div>`;
      return;
    }
    
    // Shopify ürünlerini render et
    filtered.forEach((p) => {
      const imgHTML = p.image 
        ? `<img src="${p.image}" alt="${p.title}" style="width:100%;height:100%;object-fit:cover;display:block;">`
        : `<div style="width:100%;height:100%;background:#1a1a1a;"></div>`;
      
      grid.insertAdjacentHTML('beforeend', `
        <div class="product-card" data-id="${p.id}">
          <span class="product-tag">${(p.category || 'ÜRÜN').toUpperCase()}</span>
          <div class="product-visual">${imgHTML}</div>
          <div class="product-info">
            <div class="product-name">${p.title.toUpperCase()}</div>
            <div class="product-meta">${p.description ? p.description.substring(0, 80) : ''}</div>
            <div class="product-bottom">
              <div class="product-price">${p.price}</div>
              ${p.available 
                ? `<a class="product-action" data-variant="${p.variant_id}" href="${p.url}">SEPETE EKLE →</a>`
                : `<a class="product-action" style="opacity:0.4;cursor:not-allowed;">TUKENDI</a>`
              }
            </div>
          </div>
        </div>
      `);
    });
    
    // Sepete ekle butonları (Shopify cart API)
    grid.querySelectorAll('.product-action[data-variant]').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const variantId = btn.dataset.variant;
        if (!variantId || variantId === '0') {
          window.location.href = btn.getAttribute('href');
          return;
        }
        const originalText = btn.textContent;
        btn.textContent = 'EKLENIYOR...';
        btn.style.pointerEvents = 'none';
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
          });
          if (!response.ok) throw new Error('Sepete eklenemedi');
          btn.textContent = 'EKLENDI ✓';
          btn.style.background = 'var(--lime, #C8FF3E)';
          // Sepet sayısını güncelle
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          const cartBadge = document.getElementById('cartCount');
          if (cartBadge) {
            cartBadge.textContent = cart.item_count;
            cartBadge.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
          }
          setTimeout(() => {
            btn.textContent = originalText;
            btn.style.background = '';
            btn.style.pointerEvents = '';
          }, 2000);
        } catch (err) {
          // Test ortamında /cart/add.js yok → product URL'e git
          window.location.href = btn.getAttribute('href');
        }
      });
    });
  }

  // Filtre butonları (SHOP)
  document.querySelectorAll('.filter-btn[data-cat]').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.filter-btn[data-cat]').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      renderShop(btn.dataset.cat);
    });
  });

  // ============================================================
  // WORKSHOP — ATÖLYE KATALOGU
  // ============================================================
  const WORKSHOPS = [
    {
      id: 'w-01', cat: 'cocuk', catLabel: 'ÇOCUK', catStyle: 'lime',
      title: "ESKİ İSTANBUL'DA KÂŞİFLER: ÇOCUKLAR İÇİN YARATICI DRAMA ATÖLYESİ",
      instructor: 'ÖYKÜSU ÖZYÜREK',
      desc: 'Yaratıcı drama temelli atölye. 7-10 yaş arası çocuklarla Eski İstanbul\'un sokaklarında bir keşif yolculuğu.',
      meta: { yas: '7—10 YAŞ', sure: '2 GÜN', tarih: '27-28 HAZİRAN', gun: 'CMT-PAZ 12:00-16:00', kontenjan: '10 KİŞİ' },
      price: '5.500', currency: 'TL', status: 'kayit-acik', statusText: 'KAYIT AÇIK',
      visual: 'cocuk-kasif',
      shopHandle: 'eski-istanbulda-kasifler',
      longDesc: 'Bu atölye, ortaklaşa üretim, oyun ile öğrenme ve yaratıcı ifade odaklı çalışmalar yürüten Öyküsu Özyürek tarafından yönetiliyor.\n\nAtölye Tarihi: 27-28 Haziran. Kontenjan 10 kişi ile sınırlıdır.',
      notes: [
        '7-10 yaş arası çocuklar için tasarlanmıştır.',
        'Kontenjan 10 kişi ile sınırlıdır.',
        'JUL Art House mekanında gerçekleşir.'
      ],
      bio: '5 yaşında Ekol Drama Sanat Evi\'nde başlayan oyunculuk yolculuğunu Sahne3\'te sürdürerek Kadir Has Üniversitesi Tiyatro Bölümü\'nde tamamladı. Epidaurus Theatre Festival kapsamında "Emotions and Catharsis: Transforming the Contemporary Performer\'s Body" eğitiminde performans ve oyuncu bedeni üzerine çalıştı. Oyunculuk eğitimi boyunca Stanislavski, Adler ve Meisner teknikleriyle sahne ve kamera oyunculuğu üzerine çalıştı.\n\n2017\'de "Özgürlüğün Bedeli" adlı oyundaki performansıyla Ekin Yazın Dostları Tiyatro Ödülleri — Genç Yetenek ödülünü kazandı. Televizyonda "Yalancı", "Yargı" ve "Kör Nokta" dizilerinde; sinemada ise "Aniden" başta olmak üzere çeşitli kısa ve uzun metraj filmlerde yer aldı. 2022\'de "Cehennem Boş Tüm Şeytanlar Burada" filmindeki performansıyla Uçan Süpürge Kadın Filmleri Festivali\'nden Genç Cadı ödülünü kazandı.\n\nOyunculuk çalışmalarını sahne ve ekran projelerinde sürdürürken yaratıcı drama alanında ise ortaklaşa üretim, oyun ile öğrenme ve yaratıcı ifade üzerine çalışmalar yürütmektedir.'
    },
    {
      id: 'w-03', cat: 'oyunculuk', catLabel: 'OYUNCULUK', catStyle: 'lime',
      title: 'KENDİ AKLINDAN SIYRILMAK: OYUNCULAR İÇİN MEISNER VE STANISLAVSKI TEKNİKLERİ ATÖLYESİ',
      instructor: 'CEREN KOÇ',
      desc: 'Stanislavski ve Sanford Meisner tekniklerini temel alan, Mike Alfreds\'in "Different Every Night" kitabıyla desteklenen 5 derslik oyunculuk atölyesi.',
      meta: { seviye: 'ARA / İLERİ', sure: '5 DERS', gun: '20 HAZİRAN — 4 TEMMUZ', kontenjan: '10 KİŞİ' },
      price: '10.000', currency: 'TL', status: 'kayit-acik', statusText: 'SON 2 KİŞİ',
      visual: 'oyunculuk-meisner',
      shopHandle: 'kendi-aklindan-siyrilmak-ceren-koc',
      longDesc: 'Bu atölye; kendi aklından sıyrılmış, sahnede eğlenebilen, kaygısız ve özgürleşmiş bir oyuncu hedefi taşır.\n\nAtölye boyu çalışılacak sahneler ile katılımcılar, tekniği metne aktarabilme ve partneriyle birlikte yaratabilme fırsatı bulacaktır. Oyuncu daha iyi dinleyebilmeyi, anda kalabilmeyi, itkilerini keşfedip onları eyleme dökmeyi; ambiyans / duygu / atmosfer oynamak yerine eylem oynamayı öğrenecektir.\n\n5 dersin sonunda katılımcılar, tekniği metinle birleştirdikleri 3\'er sahne çalışmasıyla süreci tamamlarlar.\n\n◆ ATÖLYE PROGRAMI:\n01. DERS — 20 Haziran Cumartesi · 16:00 — 20:00\n02. DERS — 24 Haziran Çarşamba · 19:00 — 22:30\n03. DERS — 28 Haziran Pazar · 17:00 — 22:00\n04. DERS — 01 Temmuz Çarşamba · 19:00 — 22:30\n05. DERS — 04 Temmuz Cumartesi · 16:00 — 20:00\n\n◆ ÜCRET: 10.000 TL\n\n◆ TANIŞMA WORKSHOPU: 12 Haziran Cuma, 19:30 — 21:30 saatleri arasında JUL Art House\'da ÜCRETSİZ bir tanışma workshop\'u düzenleniyor. Tekniği merak eden veya eğitmenle tanışmak isteyen herkese açıktır. Katılım için Instagram DM (@jularthouse) veya arthouse@julcreative.com.tr adresine mail göndermek yeterlidir.',
      notes: [
        'Atölye Yeri: JUL Art House — Beyoğlu / İstanbul',
        'Kontenjan 10 kişi ile sınırlıdır.',
        'Ücret: 10.000 TL (5 ders dahil)',
        'Ücretsiz tanışma workshop\'u: 12 Haziran Cuma, 19:30 — 21:30.',
        'Detaylı bilgi & başvuru: +90 531 829 75 85 veya arthouse@julcreative.com.tr'
      ],
      bio: 'İstanbul\'da doğdu ve yaşıyor. Lisans öğrenimini Kadir Has Üniversitesi Tiyatro Bölümü\'nde yaptı. Lisans eğitimi sayesinde birden çok eğitmenden ders alıp farklı disiplinleri tanıma şansı yakaladı.\n\n2019 yılında yine lisans oyunculuk dersi bünyesinde Scott Williams\'la Meisner tekniğini çalıştıktan sonra, 2021 yılında merkezi Avustralya\'da olan Impulse Company bünyesinde Scott Williams\'la "Oyunculukta Meisner Tekniği Eğitmenliği" eğitimini aldı. 2021-2023 yılları arasında Kadir Has Üniversitesi Tiyatro Bölümü 2. sınıfların oyunculuk dersinde Scott Williams\'ın asistanlığını yürüttü.\n\nKadir Has Lisans dönemi boyunca Stanislavski ve Mike Alfreds\'in eylem-istek / oyunculukta eylem çizgisi üzerine, ve Linklater Voice Method üzerine de eğitim görmüştür. Bu atölyelerle hedefi; üzerine çalıştığı ve deneyimlediği yöntemleri ekibe deneyimletebilmektir.\n\nBunların yanı sıra Ceren, aktif olarak televizyon, dijital platformlar ve sinema alanında oyunculuk yolculuğuna devam ediyor. Diğer taraftan tiyatro yönetmenliği alanında projeler yürütüyor.'
    },
    {
      id: 'w-05', cat: 'psikoloji', catLabel: 'PSİKOLOJİ', catStyle: 'lime',
      title: 'İMGENİN İZİNDE: YETİŞKİNLER İÇİN SANAT TERAPİSİ WORKSHOPU',
      instructor: 'CEREN ATMACA',
      desc: 'Serbest karalama tekniğinden yola çıkan, sanat terapisi temelli deneyim odaklı workshop. Klinik Psk. Ceren Atmaca tarafından yürütülür.',
      meta: { seviye: 'YETİŞKİN', sure: '90 DK', tarih: '21 HAZİRAN', gun: 'PAZAR 17:00-18:30', kontenjan: '15 KİŞİ' },
      price: '2.000', currency: 'TL', status: 'kayit-acik', statusText: 'KAYIT AÇIK',
      visual: 'psikoloji',
      shopHandle: 'imgenin-izinde-ceren-atmaca',
      longDesc: 'Sanat Terapisi temelli "İmgenin İzinde", serbest karalama tekniğinden yola çıkan, yetişkinler için deneyim odaklı bir workshoptur.\n\nWorkshop; Klinik psikoloji formasyonunu sanat terapisi, dışavurumcu sanat psikoterapileri ve beden odaklı yaratıcı süreçlerle bir araya getirerek çalışmalarını sürdüren Klinik Psk. Ceren Atmaca tarafından yürütülür.\n\nKatılımcılar, çizginin yönlendirdiği yere bakar — bir imgenin nereden başlayıp nereye gittiğini, kendi sesi ile sözün ötesinde nasıl temas kurduğunu fark eder. Bilinçli bir teknik çalışması değil, sürecin kendisi merkezdedir.\n\n◆ ATÖLYE BILGISI:\nTarih — 21 Haziran Pazar · 17:00 — 18:30\nSüre — 90 dakika\nKontenjan — 15 kişi\nKatılım — Yetişkin\n\n◆ ÜCRET: 2.000 TL',
      notes: [
        'Atölye Yeri: JUL Art House — Beyoğlu / İstanbul',
        'Süre: 90 dakika (tek seans)',
        'Kontenjan 15 kişi ile sınırlıdır.',
        'Yetişkinler için tasarlanmıştır.',
        'Ücret: 2.000 TL',
        'Detaylı bilgi & başvuru: +90 531 829 75 85 veya arthouse@julcreative.com.tr'
      ],
      bio: 'Ceren Atmaca, klinik psikolog ve sanat terapisi uygulayıcısıdır. Lisans eğitimini FMV Işık Üniversitesi Psikoloji Bölümü\'nde, yüksek lisans eğitimini İstanbul Gedik Üniversitesi Klinik Psikoloji Tezli Yüksek Lisans Programı\'nda tamamlamıştır. Klinik psikoloji formasyonunu sanat terapisi, dışavurumcu sanat psikoterapileri ve beden odaklı yaratıcı süreçlerle bir araya getirerek çalışmalarını sürdürmektedir.\n\nİstanbul Sanatla Yaşam bünyesinde 400 saatlik Sanat Terapisi Uygulayıcı Eğitimi\'ni tamamlamış; Tamalpa Beden Otobiyografisi, Fransız Lape Hastanesi Sanat Terapisi Klinik Uygulama Becerileri ve sanat psikoterapileri alanındaki çeşitli eğitimlerle pratiğini derinleştirmiştir. Türkiye\'de ilk kez başlayan Yetişkin Kil Alanı Terapisi Modülü\'nü tamamlamış olup bu alanda danışan görmeye devam etmektedir.\n\nHâlen ergen ve yetişkinlerle bireysel terapi, grup çalışmaları, dinamik terapi ve sanat terapisi ağırlıklı seanslar yürütmektedir. Kurucusu olduğu Ara Alan bünyesinde sanat terapisi temelli atölye ve programlar tasarlamakta; sanatın sözün ötesinde ifade, temas ve dönüşüm alanı açan yönüne odaklanmaktadır.'
    },
  ];

  // Atölye için SVG illüstrasyonları — her birine özel görsel
  function renderWorkshopSVG(visual) {
    const svgs = {
      'cocuk-kasif': `<svg viewBox="0 0 400 320" xmlns="http://www.w3.org/2000/svg">
        <rect width="400" height="320" fill="#F4F2EE"/>
        <!-- Eski Istanbul siluet -->
        <path d="M 0 240 L 40 240 L 50 200 L 60 240 L 100 240 L 120 180 L 140 240 L 180 240 L 200 160 L 220 240 L 260 240 L 280 200 L 300 240 L 340 240 L 360 220 L 400 240 L 400 320 L 0 320 Z" fill="#0A0A0A"/>
        <!-- Minareler -->
        <line x1="120" y1="180" x2="120" y2="120" stroke="#0A0A0A" stroke-width="3"/>
        <circle cx="120" cy="115" r="5" fill="#0A0A0A"/>
        <line x1="200" y1="160" x2="200" y2="90" stroke="#0A0A0A" stroke-width="3"/>
        <circle cx="200" cy="85" r="6" fill="#0A0A0A"/>
        <!-- Pusula / kasif sembol -->
        <circle cx="320" cy="80" r="35" fill="none" stroke="#0A0A0A" stroke-width="2"/>
        <path d="M 320 50 L 325 80 L 320 110 L 315 80 Z" fill="#C8FF3E"/>
        <circle cx="320" cy="80" r="4" fill="#0A0A0A"/>
      </svg>`,
      
      '3d-print': `<svg viewBox="0 0 400 320" xmlns="http://www.w3.org/2000/svg">
        <rect width="400" height="320" fill="#F4F2EE"/>
        <!-- 3D yazici cerceve -->
        <rect x="100" y="60" width="200" height="200" fill="none" stroke="#0A0A0A" stroke-width="3"/>
        <line x1="100" y1="120" x2="300" y2="120" stroke="#0A0A0A" stroke-width="2"/>
        <!-- Nozzle -->
        <rect x="190" y="105" width="20" height="20" fill="#0A0A0A"/>
        <polygon points="195,125 205,125 200,135" fill="#0A0A0A"/>
        <!-- Ureteilen obje -->
        <rect x="160" y="200" width="80" height="40" fill="#C8FF3E"/>
        <rect x="170" y="190" width="60" height="20" fill="#C8FF3E" opacity="0.7"/>
        <rect x="180" y="180" width="40" height="20" fill="#C8FF3E" opacity="0.4"/>
        <!-- Cizgiler -->
        <line x1="200" y1="135" x2="200" y2="180" stroke="#0A0A0A" stroke-width="1" stroke-dasharray="3,3"/>
      </svg>`,
      
      'oyunculuk-meisner': `<svg viewBox="0 0 400 320" xmlns="http://www.w3.org/2000/svg">
        <rect width="400" height="320" fill="#F4F2EE"/>
        <!-- Iki figur karsi karsiya -->
        <circle cx="130" cy="100" r="28" fill="none" stroke="#0A0A0A" stroke-width="3"/>
        <path d="M 100 140 Q 130 130 160 140 L 165 240 L 95 240 Z" fill="#0A0A0A"/>
        
        <circle cx="270" cy="100" r="28" fill="none" stroke="#0A0A0A" stroke-width="3"/>
        <path d="M 240 140 Q 270 130 300 140 L 305 240 L 235 240 Z" fill="#0A0A0A"/>
        
        <!-- Aralarinda enerji cizgileri -->
        <line x1="165" y1="100" x2="235" y2="100" stroke="#C8FF3E" stroke-width="4"/>
        <line x1="155" y1="115" x2="245" y2="85" stroke="#C8FF3E" stroke-width="2" opacity="0.6"/>
        <line x1="155" y1="85" x2="245" y2="115" stroke="#C8FF3E" stroke-width="2" opacity="0.6"/>
      </svg>`,
      
      'oyunculuk-kamera': `<svg viewBox="0 0 400 320" xmlns="http://www.w3.org/2000/svg">
        <rect width="400" height="320" fill="#F4F2EE"/>
        <!-- Kamera govdesi -->
        <rect x="80" y="120" width="180" height="100" rx="6" fill="#0A0A0A"/>
        <rect x="120" y="100" width="100" height="20" fill="#0A0A0A"/>
        <!-- Lens -->
        <circle cx="170" cy="170" r="45" fill="none" stroke="#0A0A0A" stroke-width="4"/>
        <circle cx="170" cy="170" r="30" fill="#0A0A0A"/>
        <circle cx="170" cy="170" r="15" fill="#F4F2EE"/>
        <circle cx="170" cy="170" r="8" fill="#0A0A0A"/>
        <!-- Rec lambasi -->
        <circle cx="240" cy="135" r="6" fill="#C8FF3E"/>
        <!-- Oyuncu silueti sagda -->
        <circle cx="340" cy="130" r="22" fill="none" stroke="#0A0A0A" stroke-width="2.5"/>
        <path d="M 318 165 Q 340 158 362 165 L 365 240 L 315 240 Z" fill="none" stroke="#0A0A0A" stroke-width="2.5"/>
      </svg>`,
      
      'tai-chi': `<svg viewBox="0 0 400 320" xmlns="http://www.w3.org/2000/svg">
        <rect width="400" height="320" fill="#F4F2EE"/>
        <!-- Tai chi figuru, akan poz -->
        <circle cx="200" cy="80" r="22" fill="none" stroke="#0A0A0A" stroke-width="3"/>
        <!-- Govde -->
        <path d="M 200 102 Q 195 140 200 180" stroke="#0A0A0A" stroke-width="3" fill="none"/>
        <!-- Kollar - akis pozu -->
        <path d="M 200 120 Q 150 130 100 110" stroke="#0A0A0A" stroke-width="3" fill="none"/>
        <path d="M 200 130 Q 250 150 300 180" stroke="#0A0A0A" stroke-width="3" fill="none"/>
        <!-- Bacaklar -->
        <line x1="200" y1="180" x2="170" y2="260" stroke="#0A0A0A" stroke-width="3"/>
        <line x1="200" y1="180" x2="230" y2="260" stroke="#0A0A0A" stroke-width="3"/>
        <!-- Yin yang -->
        <circle cx="320" cy="60" r="20" fill="none" stroke="#0A0A0A" stroke-width="2"/>
        <path d="M 320 40 A 20 20 0 0 1 320 80 A 10 10 0 0 0 320 60 A 10 10 0 0 1 320 40 Z" fill="#0A0A0A"/>
        <circle cx="320" cy="50" r="2" fill="#F4F2EE"/>
        <circle cx="320" cy="70" r="2" fill="#0A0A0A"/>
        <!-- Enerji halkasi -->
        <ellipse cx="200" cy="170" rx="120" ry="20" fill="none" stroke="#C8FF3E" stroke-width="2" opacity="0.6"/>
      </svg>`,
      
      'farkindalik': `<svg viewBox="0 0 400 320" xmlns="http://www.w3.org/2000/svg">
        <rect width="400" height="320" fill="#F4F2EE"/>
        <!-- Yerde uzanmis figur -->
        <line x1="60" y1="220" x2="340" y2="220" stroke="#0A0A0A" stroke-width="2"/>
        <ellipse cx="100" cy="200" rx="22" ry="18" fill="none" stroke="#0A0A0A" stroke-width="2.5"/>
        <path d="M 122 195 L 280 200 L 320 215 L 280 220 L 122 215 Z" fill="#0A0A0A"/>
        <!-- Nefes halkalari -->
        <circle cx="100" cy="200" r="40" fill="none" stroke="#C8FF3E" stroke-width="1.5" opacity="0.7"/>
        <circle cx="100" cy="200" r="60" fill="none" stroke="#C8FF3E" stroke-width="1" opacity="0.5"/>
        <circle cx="100" cy="200" r="80" fill="none" stroke="#C8FF3E" stroke-width="1" opacity="0.3"/>
        <circle cx="100" cy="200" r="100" fill="none" stroke="#C8FF3E" stroke-width="1" opacity="0.15"/>
      </svg>`,
      
      'ai-gorsel': `<svg viewBox="0 0 400 320" xmlns="http://www.w3.org/2000/svg">
        <rect width="400" height="320" fill="#F4F2EE"/>
        <!-- Sol: Prompt metin kutusu -->
        <rect x="40" y="100" width="120" height="120" fill="none" stroke="#0A0A0A" stroke-width="2"/>
        <line x1="55" y1="125" x2="145" y2="125" stroke="#0A0A0A" stroke-width="2"/>
        <line x1="55" y1="140" x2="135" y2="140" stroke="#0A0A0A" stroke-width="2"/>
        <line x1="55" y1="155" x2="145" y2="155" stroke="#0A0A0A" stroke-width="2"/>
        <line x1="55" y1="170" x2="125" y2="170" stroke="#0A0A0A" stroke-width="2"/>
        <line x1="55" y1="185" x2="140" y2="185" stroke="#0A0A0A" stroke-width="2"/>
        <line x1="55" y1="200" x2="115" y2="200" stroke="#0A0A0A" stroke-width="2"/>
        <!-- Ok -->
        <line x1="175" y1="160" x2="225" y2="160" stroke="#0A0A0A" stroke-width="3"/>
        <polygon points="225,155 235,160 225,165" fill="#0A0A0A"/>
        <!-- Sag: Olusan goruntu -->
        <rect x="245" y="100" width="120" height="120" fill="#0A0A0A"/>
        <circle cx="280" cy="140" r="15" fill="#C8FF3E"/>
        <rect x="300" y="160" width="50" height="40" fill="#F4F2EE"/>
        <path d="M 255 200 L 280 175 L 305 195 L 330 170 L 355 210 L 355 215 L 255 215 Z" fill="#C8FF3E" opacity="0.6"/>
      </svg>`,
      
      'film-foto': `<svg viewBox="0 0 400 320" xmlns="http://www.w3.org/2000/svg">
        <rect width="400" height="320" fill="#F4F2EE"/>
        <!-- Eski 35mm fotoarc makinesi -->
        <rect x="100" y="130" width="200" height="120" rx="8" fill="#0A0A0A"/>
        <rect x="140" y="115" width="120" height="20" rx="3" fill="#0A0A0A"/>
        <!-- Lens disardi -->
        <circle cx="200" cy="190" r="50" fill="#0A0A0A" stroke="#F4F2EE" stroke-width="3"/>
        <circle cx="200" cy="190" r="38" fill="none" stroke="#F4F2EE" stroke-width="1.5"/>
        <circle cx="200" cy="190" r="25" fill="#F4F2EE"/>
        <circle cx="200" cy="190" r="18" fill="#0A0A0A"/>
        <circle cx="200" cy="190" r="8" fill="#C8FF3E"/>
        <!-- Sutter dugmesi -->
        <circle cx="270" cy="140" r="6" fill="#C8FF3E"/>
        <!-- Film makarasi -->
        <circle cx="130" cy="155" r="10" fill="none" stroke="#F4F2EE" stroke-width="2"/>
        <circle cx="130" cy="155" r="4" fill="#F4F2EE"/>
      </svg>`,
      
      'psikoloji': `<svg viewBox="0 0 400 320" xmlns="http://www.w3.org/2000/svg">
        <rect width="400" height="320" fill="#F4F2EE"/>
        <!-- Yan profil kafa -->
        <path d="M 150 100 Q 130 90 130 140 Q 130 175 140 200 L 160 220 L 200 230 L 230 220 L 250 210 L 260 180 Q 260 150 245 130 Q 230 100 200 95 Z" fill="none" stroke="#0A0A0A" stroke-width="3"/>
        <!-- Beyin icinde dusunce dolambaclari -->
        <path d="M 175 130 Q 180 140 175 150 Q 165 160 180 170 Q 200 165 195 180" fill="none" stroke="#C8FF3E" stroke-width="2.5"/>
        <path d="M 200 135 Q 215 145 210 160 Q 200 170 215 175" fill="none" stroke="#C8FF3E" stroke-width="2.5"/>
        <!-- Goz -->
        <circle cx="220" cy="155" r="5" fill="#0A0A0A"/>
        <!-- Ic dunya cizgileri disari -->
        <path d="M 100 140 Q 120 130 145 140" stroke="#0A0A0A" stroke-width="1.5" fill="none" stroke-dasharray="3,3"/>
        <path d="M 90 170 Q 115 165 140 175" stroke="#0A0A0A" stroke-width="1.5" fill="none" stroke-dasharray="3,3"/>
      </svg>`,
      
      'felsefe': `<svg viewBox="0 0 400 320" xmlns="http://www.w3.org/2000/svg">
        <rect width="400" height="320" fill="#F4F2EE"/>
        <!-- Acik kitap -->
        <path d="M 80 120 L 200 100 L 200 240 L 80 220 Z" fill="#F4F2EE" stroke="#0A0A0A" stroke-width="3"/>
        <path d="M 320 120 L 200 100 L 200 240 L 320 220 Z" fill="#F4F2EE" stroke="#0A0A0A" stroke-width="3"/>
        <!-- Sol sayfa yazi -->
        <line x1="100" y1="140" x2="180" y2="135" stroke="#0A0A0A" stroke-width="1.5"/>
        <line x1="100" y1="155" x2="175" y2="150" stroke="#0A0A0A" stroke-width="1.5"/>
        <line x1="100" y1="170" x2="185" y2="165" stroke="#0A0A0A" stroke-width="1.5"/>
        <line x1="100" y1="185" x2="170" y2="180" stroke="#0A0A0A" stroke-width="1.5"/>
        <line x1="100" y1="200" x2="180" y2="195" stroke="#0A0A0A" stroke-width="1.5"/>
        <!-- Sag sayfa yazi -->
        <line x1="220" y1="135" x2="300" y2="140" stroke="#0A0A0A" stroke-width="1.5"/>
        <line x1="225" y1="150" x2="300" y2="155" stroke="#0A0A0A" stroke-width="1.5"/>
        <line x1="215" y1="165" x2="305" y2="170" stroke="#0A0A0A" stroke-width="1.5"/>
        <line x1="220" y1="180" x2="295" y2="185" stroke="#0A0A0A" stroke-width="1.5"/>
        <!-- Onemli not isareti -->
        <rect x="100" y="135" width="40" height="3" fill="#C8FF3E"/>
        <!-- Bookmark -->
        <rect x="195" y="100" width="10" height="60" fill="#C8FF3E"/>
      </svg>`
    };
    return svgs[visual] || svgs['felsefe'];
  }

  function renderWorkshops(filter = 'all') {
    const grid = document.getElementById('workshopGrid');
    if (!grid) return;
    grid.innerHTML = '';
    
    const filtered = filter === 'all' ? WORKSHOPS : WORKSHOPS.filter(w => w.cat === filter);
    
    filtered.forEach((w, i) => {
      const itemCls = w.status === 'full' ? 'workshop-item full' : 'workshop-item';
      const imgPath = julAsset(w.id + ".jpg");
      const num = String(i + 1).padStart(2, '0');
      
      // Status class - YAKINDA için gri, FULL için siyah, KAYIT AÇIK için lime
      let statusCls = '';
      if (w.statusText === 'YAKINDA') statusCls = 'yakinda';
      else if (w.status === 'full') statusCls = 'full';
      
      // Boş atölye kontrolü
      const isEmpty = !w.title;
      const displayTitle = isEmpty ? '—' : w.title;
      const displayCat = w.catLabel;
      
      // Meta bilgilerini object'ten al
      const metaEntries = Object.entries(w.meta).filter(([k, v]) => v);
      const metaHTML = metaEntries.length > 0 
        ? metaEntries.map(([k, v]) => 
            `<div class="wcard-meta-row"><span class="k">${k}</span><span class="v">${v}</span></div>`
          ).join('')
        : '<div class="wcard-meta-empty">Detaylar yakında açıklanacak.</div>';
      
      const instructorDisp = w.instructor || '—';
      const descDisp = w.desc || 'Bu atölye için detaylar yakında paylaşılacak.';
      const priceDisp = w.price || '—';
      
      grid.insertAdjacentHTML('beforeend', `
        <div class="${itemCls}" data-id="${w.id}" ${!isEmpty ? `data-clickable="1"` : ''}>
          <!-- ON YUZ -->
          <div class="wcard-face wcard-front">
            <div class="wcard-visual">
              <img src="${imgPath}" alt="${w.title}" loading="lazy"
                onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';">
              <div class="placeholder" style="display:none;">${displayTitle}</div>
            </div>
            <div class="wcard-front-info">
              <div class="wcard-front-meta">
                <span class="wcard-front-num">${num} / ${String(filtered.length).padStart(2,'0')}</span>
                <span class="wcard-front-status ${statusCls}">${w.statusText}</span>
              </div>
              <div class="wcard-front-cat">${displayCat}</div>
              <div class="wcard-front-title">${displayTitle}</div>
            </div>
          </div>
          
          <!-- ARKA YUZ -->
          <div class="wcard-face wcard-back">
            <div class="wcard-back-top">
              <div class="wcard-back-cat">${displayCat} · ${num}</div>
              <div class="wcard-back-title">${displayTitle}</div>
              <div class="wcard-back-instructor">${instructorDisp}</div>
              <p class="wcard-back-desc">${descDisp}</p>
            </div>
            <div class="wcard-back-meta">
              ${metaHTML}
            </div>
            <div class="wcard-back-bottom">
              <div class="wcard-back-price">${priceDisp}${w.currency ? `<span class="currency">${w.currency}</span>` : ''}</div>
              <a class="wcard-back-action">${isEmpty ? '—' : (w.status === 'full' ? 'YEDEK LISTE →' : 'DETAY →')}</a>
            </div>
          </div>
        </div>
      `);
    });
    
    // Kartlara tıklama olayı - detay sayfasına yönlendir
    grid.querySelectorAll('.workshop-item[data-clickable="1"]').forEach(item => {
      item.addEventListener('click', (e) => {
        const id = item.dataset.id;
        openWorkshopDetail(id);
      });
    });
  }
  
  // ============================================================
  // WORKSHOP DETAY SAYFASI — dinamik içerik
  // ============================================================
  function openWorkshopDetail(id) {
    const w = WORKSHOPS.find(x => x.id === id);
    if (!w || !w.title) return;
    
    const detailPage = document.getElementById('page-workshop-detail');
    if (!detailPage) return;
    
    const metaEntries = Object.entries(w.meta).filter(([k, v]) => v);
    const metaHTML = metaEntries.map(([k, v]) => 
      `<div class="row"><span class="key">${k}</span><span class="val">${v}</span></div>`
    ).join('');
    
    detailPage.querySelector('.wd-cat').textContent = w.catLabel;
    detailPage.querySelector('.wd-title').textContent = w.title;
    detailPage.querySelector('.wd-instructor').textContent = w.instructor;
    detailPage.querySelector('.wd-desc').textContent = w.desc;
    detailPage.querySelector('.wd-details').innerHTML = metaHTML;
    detailPage.querySelector('.wd-price').textContent = w.price + (w.currency ? ' ' + w.currency : '');
    detailPage.querySelector('.wd-status').textContent = w.statusText;
    
    // UZUN AÇIKLAMA - paragraf paragraf
    const longDescEl = detailPage.querySelector('.wd-longdesc');
    if (longDescEl) {
      if (w.longDesc) {
        const paragraphs = w.longDesc.split('\n\n').filter(p => p.trim());
        longDescEl.innerHTML = paragraphs.map(p => `<p>${p.trim()}</p>`).join('');
        longDescEl.style.display = '';
      } else {
        longDescEl.style.display = 'none';
      }
    }
    
    // NOTLAR LİSTESİ
    const notesEl = detailPage.querySelector('.wd-notes');
    if (notesEl) {
      if (w.notes && w.notes.length > 0) {
        notesEl.innerHTML = w.notes.map(n => `<li>${n}</li>`).join('');
        notesEl.style.display = '';
      } else {
        notesEl.style.display = 'none';
      }
    }
    
    // BIYOGRAFI
    const bioBlock = detailPage.querySelector('.wd-bio-block');
    const bioName = detailPage.querySelector('.wd-bio-name');
    const bioText = detailPage.querySelector('.wd-bio-text');
    if (bioBlock) {
      if (w.bio) {
        if (bioName) bioName.textContent = w.instructor || '';
        if (bioText) {
          const paragraphs = w.bio.split('\n\n').filter(p => p.trim());
          bioText.innerHTML = paragraphs.map(p => `<p>${p.trim()}</p>`).join('');
        }
        bioBlock.style.display = '';
      } else {
        bioBlock.style.display = 'none';
      }
    }
    
    // Status dot rengi
    const statusDot = detailPage.querySelector('.wd-status-dot');
    if (statusDot) {
      statusDot.style.background = w.status === 'full' 
        ? 'rgba(10,10,10,0.5)' 
        : (w.statusText === 'YAKINDA' ? 'rgba(10,10,10,0.3)' : 'var(--lime)');
    }
    
    // Visual - placeholder her zaman göster, görsel yüklenince üstüne çıkar
    const visualEl = detailPage.querySelector('.wd-visual');
    const imgPath = julAsset(w.id + ".jpg");
    visualEl.innerHTML = `
      <div class="placeholder">${w.title}</div>
      <img src="${imgPath}" alt="${w.title}" style="opacity:0;transition:opacity 0.4s ease;"
        onload="this.style.opacity='1'; const p=this.previousElementSibling; if(p) p.style.display='none';"
        onerror="this.remove();">
    `;
    
    // KAYIT OL butonu — yeni event listener (clone trick ile temizle)
    const kayitBtn = detailPage.querySelector('.wd-kayit-btn');
    if (kayitBtn) {
      const newKayitBtn = kayitBtn.cloneNode(true);
      kayitBtn.parentNode.replaceChild(newKayitBtn, kayitBtn);
      const valueSpan = newKayitBtn.querySelector('.value');
      
      if (w.status === 'full') {
        // Dolu — disable
        newKayitBtn.removeAttribute('href');
        newKayitBtn.style.opacity = '0.5';
        newKayitBtn.style.pointerEvents = 'none';
        if (valueSpan) valueSpan.textContent = 'KONTENJAN DOLDU';
      } else if (w.shopHandle) {
        // Shopify ortamında ise direkt product sayfası, değilse WhatsApp
        const isShopify = typeof window.Shopify !== 'undefined' || window.location.pathname.includes('/products/');
        if (isShopify) {
          newKayitBtn.setAttribute('href', `/products/${w.shopHandle}`);
          newKayitBtn.removeAttribute('target');
          newKayitBtn.removeAttribute('rel');
          if (valueSpan) valueSpan.textContent = "SHOP'TA SATIN AL →";
        } else {
          // Test versiyonu - WhatsApp
          const mesaj = `Merhaba, "${w.title}" atölyesine kayıt olmak istiyorum.`;
          newKayitBtn.setAttribute('href', `https://wa.me/905318297585?text=${encodeURIComponent(mesaj)}`);
          newKayitBtn.setAttribute('target', '_blank');
          newKayitBtn.setAttribute('rel', 'noopener');
          if (valueSpan) valueSpan.textContent = 'WHATSAPP REZERVE →';
        }
      } else {
        // WhatsApp'a yönlendir
        const mesaj = `Merhaba, "${w.title}" atölyesine kayıt olmak istiyorum.`;
        newKayitBtn.setAttribute('href', `https://wa.me/905318297585?text=${encodeURIComponent(mesaj)}`);
        newKayitBtn.setAttribute('target', '_blank');
        newKayitBtn.setAttribute('rel', 'noopener');
        if (valueSpan) valueSpan.textContent = 'WHATSAPP →';
      }
    }
    
    showPage('workshop-detail');
  }

  // Filtre butonları (WORKSHOP)
  document.querySelectorAll('.wfilter').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.wfilter').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      renderWorkshops(btn.dataset.wcat);
    });
  });

  // VİDEO + NAV
  const home = document.getElementById('home');
  const about = document.getElementById('about');
  const selections = document.getElementById('selections');
  const pages = document.querySelectorAll('.page');
  const navLinks = document.querySelectorAll('.home nav a');
  const backBtns = document.querySelectorAll('[data-back]');
  const calendarLinks = document.querySelectorAll('[data-calendar-link]');
  const bgVideoWrap = document.getElementById('bgVideo');
  const bgVideoEl = document.getElementById('bgVideoEl');
  
  // TAKVIM linkleri - tıklayınca modal aç
  const calendarModal = document.getElementById('calendar-modal');
  const calendarModalClose = document.getElementById('calendarModalClose');
  
  function openCalendar() {
    if (calendarModal) {
      calendarModal.classList.add('active');
      calendarModal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
  }
  function closeCalendar() {
    if (calendarModal) {
      calendarModal.classList.remove('active');
      calendarModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      // Detay paneli de kapat
      const detail = document.getElementById('calendarDetail');
      if (detail) detail.classList.remove('active');
    }
  }
  
  calendarLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      openCalendar();
    });
  });
  
  // EVENT DELEGATION — dinamik render edilen tüm TAKVIM butonlarının çalışmasını garantiler
  document.addEventListener('click', (e) => {
    const calLink = e.target.closest('[data-calendar-link]');
    if (calLink) {
      e.preventDefault();
      openCalendar();
    }
  });
  
  // Global olarak da expose et (Workshop sayfasından çağrılmak için)
  window.openCalendar = openCalendar;
  
  if (calendarModalClose) calendarModalClose.addEventListener('click', closeCalendar);
  
  // ESC ile kapat
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && calendarModal && calendarModal.classList.contains('active')) {
      closeCalendar();
    }
  });
  
  // Modal'ın dışına tıklayınca kapat (backdrop tıklama)
  if (calendarModal) {
    calendarModal.addEventListener('click', (e) => {
      if (e.target === calendarModal) closeCalendar();
    });
  }
  
  // URL'de #calendar hash varsa otomatik aç
  if (window.location.hash === '#calendar') {
    setTimeout(openCalendar, 200);
  }

  const videoMap = {
    'stage': julAsset('stage.mp4'),
    'studio-a': julAsset('studio-a.mp4'),
    'studio-b': julAsset('studio-b.mp4'),
    'gallery': julAsset('gallery.mp4'),
    'workshop': julAsset('workshop.mp4'),
    'shop': julAsset('shop.mp4'),
    'headshot': julAsset('headshot.mp4'),
    'self-tape': julAsset('self-tape.mp4')
  };

  navLinks.forEach(link => {
    link.addEventListener('mouseenter', () => {
      const v = link.getAttribute('data-video');
      if (videoMap[v]) {
        const src = videoMap[v];
        bgVideoEl.innerHTML = `<source src="${src}" type="video/mp4">`;
        bgVideoEl.load();
        bgVideoEl.loop = true;
        bgVideoEl.muted = true;
        bgVideoEl.playsInline = true;
        bgVideoEl.play().catch(() => {});
        bgVideoWrap.classList.add('active');
        document.body.classList.add('video-active');
      }
    });
    link.addEventListener('mouseleave', () => {
      bgVideoWrap.classList.remove('active');
      document.body.classList.remove('video-active');
      setTimeout(() => {
        if (!bgVideoWrap.classList.contains('active')) {
          bgVideoEl.pause();
          bgVideoEl.innerHTML = '';
          bgVideoEl.removeAttribute('src');
          bgVideoEl.load();
        }
      }, 500);
    });
  });

  function showPage(id) {
    home.style.display = 'none';
    about.style.display = 'none';
    selections.style.display = 'none';
    pages.forEach(p => p.classList.remove('active'));
    const target = document.getElementById('page-' + id);
    if (target) { target.classList.add('active'); window.scrollTo(0, 0); }
    
    // Shop'a girince ürünleri render et
    if (id === 'shop') {
      setTimeout(() => renderShop('all'), 100);
    }
    // Workshop'a girince atölyeleri render et
    if (id === 'workshop') {
      setTimeout(() => renderWorkshops('all'), 100);
    }
    // Herhangi bir sayfada sa-section-visual varsa video hover'larını kur
    setTimeout(() => {
      document.querySelectorAll('#page-' + id + ' .sa-section-visual').forEach(visual => {
        if (visual.dataset.hoverReady === '1') return;
        visual.dataset.hoverReady = '1';
        const video = visual.querySelector('video');
        const placeholder = visual.querySelector('.placeholder');
        if (!video || !video.dataset.src) return;
        
        visual.addEventListener('mouseenter', () => {
          if (!video.src) {
            video.innerHTML = `<source src="${video.dataset.src}" type="video/mp4">`;
            video.load();
          }
          video.currentTime = 0;
          video.play().then(() => {
            if (placeholder) placeholder.style.display = 'none';
          }).catch(() => {});
        });
        visual.addEventListener('mouseleave', () => {
          video.pause();
          if (placeholder) placeholder.style.display = '';
        });
      });
    }, 100);
  }

  function showHome() {
    pages.forEach(p => p.classList.remove('active'));
    home.style.display = 'flex';
    about.style.display = 'block';
    selections.style.display = 'block';
    window.scrollTo(0, 0);
  }

  navLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const page = link.getAttribute('data-page');
      showPage(page);
      history.pushState({page: page}, '', '#' + page);
    });
  });

  backBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      showHome();
      history.pushState({page: null}, '', '#');
    });
  });

  window.addEventListener('popstate', (e) => {
    if (e.state && e.state.page) showPage(e.state.page);
    else showHome();
  });

  const hash = window.location.hash.replace('#', '');
  if (hash && hash !== 'calendar' && document.getElementById('page-' + hash)) {
    showPage(hash);
  }
